import PropTypes from "prop-types"
import React, { useState, useEffect, useRef } from "react"
import {
  Container,
  Row,
  Col,
  // Button,
  Card,
  CardBody,
  Input,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap"
import axios from "axios"
import moment from "moment";
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { useNavigate, useParams } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import { TriStateCheckbox } from "primereact/tristatecheckbox"
import { Checkbox } from "primereact/checkbox";
import { FileUpload } from 'primereact/fileupload';
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from 'primereact/inputtextarea';
import { TreeSelect } from "primereact/treeselect";
import { useForm } from "react-hook-form";
import Select from 'react-select';
import WorkType1 from "../common-for-all/WorkTypeOne"
import { 
  getEmployee, 
  createEmployee, 
  updateEmployee, 
  getCompanies, 
  getLookupsByName,
  getEmployees,
  createEntityDocument,
  getEntityDocuments
} from "../../helpers/backend-helper"
import { getCookie } from '../../helpers/cookie';
import { Chips } from "primereact/chips";

//i18n

const EmployeeEditForm = props => {
  const navigate = useNavigate();
  // const { id: employeeId } = useParams(); // Get employee ID from URL
  const toast = useRef(null);
  const token = getCookie('access_token');
    const params = new URLSearchParams(window.location.search);
    const employeeId = params.get("id");
  // Determine if we're in edit mode
  const isEditMode = Boolean(employeeId);
  const fileUploadRef = useRef(null);
  const [menu, setMenu] = useState(false)
  const toggle = () => {
    setMenu(!menu)
  }
  // document.title = "CandidateEditForm | Pms - React Admin & CandidateEditForm Template";

  const [selectedCity, setSelectedCity] = useState("Hyderabad")
  const cities = [
    { name: "Work From Office", code: "emp1" },
    { name: "Work From Remote", code: "emp2" },
    { name: "Work From Home", code: "emp3" },
    { name: "Freelancer", code: "emp4" },

  ]

  const [selectedStatus, setSelectedStatus] = useState(null)
  const [dateFromTo, setDateFromTo] = useState(null);


  const [fullname, setFullname] = useState("");
  const [fullNameDialogVisible, setFullNameDialogVisible] = useState(false);
  const [nameTitle, setNameTitle] = useState('');
  const [dialogFirstName, setDialogFirstName] = useState('');
  const [dialogMiddleName, setDialogMiddleName] = useState('');
  const [dialogLastName, setDialogLastName] = useState('');

  // Employee data loading state
  const [employeeData, setEmployeeData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    primary_email: "",
    secondary_email: "",
    personal_phone: "",
    office_phone: "",
    designation: "",
    company: null,
    date_of_joining: null,
    primary_skills: [],
    address: ""
  });

  // Private functionality state
  const [privateDrop, setPrivateDrop] = useState(false);
  const [PrivetDropdown, setPrivetDropdown] = useState([]);
  const [PrivetDropdownValues, setPrivetDropdownValues] = useState([]);
  const getPrivateOptions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/private-users/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        let results = response.data.data;
        console.log(results, 'results');
        const options = results.map((category) => ({
          name: category.name
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase()),
          code: category.id,
          email: category.email,
        }));
        setPrivetDropdownValues(options);
      }
    } catch (error) {

    }
  };
  useEffect(() => {
    getPrivateOptions();
  }, []);

  const [company, setCompany] = useState("Varun Digital Media");

  // Company work type start
  const [selectedModule, setSelectedModule] = useState(null)
  
  const [moduleWorkTypes, setModuleWorkTypes] = useState([])

  const moduleDropdownWorkTypes = [
    ...moduleWorkTypes,
    // { id: "divider", disabled: true },
    // { name: "Add Company", id: "create-new-work-type" },
    // { name: "Edit Company", id: "edit-selected-work-type" },
  ]

  const handleModuleWorkTypesChange = updatedWorkTypes => {
    setModuleWorkTypes(updatedWorkTypes)
  }

  const handleModuleSelectionChange = selectedWorkType => {
    setSelectedModule(selectedWorkType)
  }
  // Company work type end

  // Designation work type start
  const [selectedDesignation, setSelectedDesignation] = useState(null)
  
  const [designationWorkTypes, setDesignationWorkTypes] = useState([])

  const designationDropdownWorkTypes = designationWorkTypes

  const handleDesignationWorkTypesChange = updatedWorkTypes => {
    setDesignationWorkTypes(updatedWorkTypes)
  }

  const handleDesignationSelectionChange = selectedWorkType => {
    setSelectedDesignation(selectedWorkType)
  }
  // Designation work type end

  // Department work type start
  const [selectedDepartment, setSelectedDepartment] = useState(null)
  const [departmentWorkTypes, setDepartmentWorkTypes] = useState([])
  const departmentDropdownWorkTypes = departmentWorkTypes

  const handleDepartmentWorkTypesChange = updatedWorkTypes => {
    setDepartmentWorkTypes(updatedWorkTypes)
    console.log(updatedWorkTypes,'updatedWorkTypes');
    
  }

  const handleDepartmentSelectionChange = selectedWorkType => {
    console.log(selectedWorkType,'selectedWorkType');
    
    setSelectedDepartment(selectedWorkType)
  }
  // Department work type end

  // Work Location API data
  const [workLocationAPIData, setWorkLocationAPIData] = useState([]);

  // Shift Timings API data
  const [shiftTimingsAPIData, setShiftTimingsAPIData] = useState([]);

  // Employee Status API data (for General Information - employee_employeeStatus)
  const [employeeStatusAPIData, setEmployeeStatusAPIData] = useState([]);

  // Basic Status API data (for Basic Information - employee_status)
  const [basicStatusAPIData, setBasicStatusAPIData] = useState([]);

  // Employee Type API data
  const [employeeTypeAPIData, setEmployeeTypeAPIData] = useState([]);

  // Employees API data for Reporting Manager
  const [employeesAPIData, setEmployeesAPIData] = useState([]);

  // Categories API data
  const [categoriesAPIData, setCategoriesAPIData] = useState([]);

  // Groups API data
  const [groupsAPIData, setGroupsAPIData] = useState([]);

  // Other Skills API data
  const [otherSkillsAPIData, setOtherSkillsAPIData] = useState([]);

  // Primary Skills API data
  const [primarySkillsAPIData, setPrimarySkillsAPIData] = useState([]);

  // Secondary Skills API data
  const [secondarySkillsAPIData, setSecondarySkillsAPIData] = useState([]);

  // Sub Department API data
  const [subDepartmentAPIData, setSubDepartmentAPIData] = useState([]);

  // Lookup modal state for Add/Edit sentinels
  const [lookupModalVisible, setLookupModalVisible] = useState(false)
  const [lookupModalContext, setLookupModalContext] = useState('') // 'designation' | 'department' | 'employee_status' | 'employee_type' | 'shift_timings' | 'sub_department' | 'work_location'
  const [lookupFormValue, setLookupFormValue] = useState('')
  const [editingLookup, setEditingLookup] = useState(false)
  const [lastSelectedLookupId, setLastSelectedLookupId] = useState(null)
  const [lookupDescription, setLookupDescription] = useState('')
  const [selectedEditdrop, setSelectedEditdrop] = useState(null)
  const [selecteddropoptions, setselecteddropoptions] = useState([])

  const lookupAddSentinel = { value: 'add', label: 'Add New', icon: 'pi pi-plus' }
  const lookupEditSentinel = { value: 'edit', label: 'Edit Selected', icon: 'pi pi-pencil' }

  // helper to get label from option arrays (handles different shapes)
  const getOptionLabel = (options, val) => {
    if (!options || val == null) return ''
    const found = options.find(o => o.value === val || o.code === val || o.id === val)
    if (!found) return ''
    return found.label || found.name || found.value || String(found.code || found.id || '')
  }

  // Save (POST or PATCH) for the shared lookup modal
  const handleLookupSave = async () => {
    const lookupNameMap = {
      designation: 'employee_designation',
      department: 'employee_department', 
      employee_status: 'employee_status',
      employee_type: 'employee_type',
      shift_timings: 'shift_timings',
      sub_department: 'employee_subDepartment',
      work_location: 'work_location'
    }
    const lookupName = lookupNameMap[lookupModalContext]
    if (!lookupName) return
    try {
      if (!lookupFormValue || lookupFormValue.trim() === '') {
        toast.current && toast.current.show({ severity: 'error', summary: 'Error', detail: 'Value is required' })
        return
      }
      if (editingLookup && lastSelectedLookupId) {
        await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedLookupId}/`, {
          name: lookupName,
          value: lookupFormValue,
          description: lookupDescription || lookupFormValue,
        }, { 
          headers: { 
            Authorization: `Bearer ${getCookie("access_token")}` 
          } 
        })
      } else {
        await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, {
          name: lookupName,
          value: lookupFormValue,
          description: lookupDescription || lookupFormValue,
          type: 'employee'
        }, { 
          headers: { 
            Authorization: `Bearer ${getCookie("access_token")}` 
          } 
        })
      }

      // refresh lists
      if (lookupModalContext === 'designation') await loadDesignationData()
      if (lookupModalContext === 'department') await loadDepartmentData()
      if (lookupModalContext === 'employee_status') await loadBasicStatusData()
      if (lookupModalContext === 'employee_type') await loadEmployeeTypeData()
      if (lookupModalContext === 'shift_timings') await loadShiftTimingsData()
      if (lookupModalContext === 'sub_department') await loadSubDepartmentData()
      if (lookupModalContext === 'work_location') await loadWorkLocationData()

      setLookupModalVisible(false)
      setLookupFormValue('')
      setLookupDescription('')
      setEditingLookup(false)
      setLastSelectedLookupId(null)
      toast.current && toast.current.show({ severity: 'success', summary: 'Saved', detail: 'Lookup saved' })
    } catch (err) {
      console.error('Lookup save failed', err)
      toast.current && toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to save lookup' })
    }
  }

  // populate the edit-select dropdown options based on which lookup is being edited
  useEffect(() => {
    const normalize = (arr) => (arr || []).
      // remove sentinel entries (value 'add' or 'edit') before mapping
      filter(o => !(o && (o.value === 'add' || o.value === 'edit' || o.label === 'Add New' || o.label === 'Edit Selected')))
      .map((o) => ({
        id: o.id ?? o.code ?? o.value,
        name: o.name ?? o.label ?? o.value ?? String(o.code ?? o.id ?? ''),
        raw: o,
      }))

    if (lookupModalContext === 'designation') {
      setselecteddropoptions(normalize(designationWorkTypes))
      return
    }
    if (lookupModalContext === 'department') {
      setselecteddropoptions(normalize(departmentWorkTypes))
      return
    }
    if (lookupModalContext === 'employee_status') {
      setselecteddropoptions(normalize(basicStatusAPIData))
      return
    }
    if (lookupModalContext === 'employee_type') {
      setselecteddropoptions(normalize(employeeTypeAPIData))
      return
    }
    if (lookupModalContext === 'shift_timings') {
      setselecteddropoptions(normalize(shiftTimingsAPIData))
      return
    }
    if (lookupModalContext === 'sub_department') {
      setselecteddropoptions(normalize(subDepartmentAPIData))
      return
    }
    if (lookupModalContext === 'work_location') {
      setselecteddropoptions(normalize(workLocationAPIData))
      return
    }
    setselecteddropoptions([])
  }, [lookupModalContext, designationWorkTypes, departmentWorkTypes, basicStatusAPIData, employeeTypeAPIData, shiftTimingsAPIData, subDepartmentAPIData, workLocationAPIData])

  // render template for dropdown items so sentinel rows show icons
  const dropdownItemTemplate = (option) => {
    if (!option) return null
    // handle sentinel shapes { value: 'add'|'edit', label: 'Add New'|'Edit Selected' }
    if (option.value === 'add' || option.value === 'edit' || option.label === 'Add New' || option.label === 'Edit Selected') {
      const isAdd = option.value === 'add' || option.label === 'Add New'
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <i className={isAdd ? 'pi pi-plus' : 'pi pi-pencil'} style={{ fontSize: '1rem' }} />
          <span>{option.label || option.name || option.value}</span>
        </div>
      )
    }
    // default rendering
    return <div>{option.label ?? option.name ?? option.value}</div>
  }

  // Lookup modal sentinel handler for WorkType1 components
  const handleSentinelSelect = (context, lookupField) => {
    // Map lookup field to existing modal context
    const lookupFieldMap = {
      'company': 'company',
      'employee_designation': 'designation', 
      'employee_department': 'department',
      'employee_subDepartment': 'sub_department',
      'employee_workLocation': 'work_location',
      'employee_shiftTimings': 'shift_timings',
      'employee_employeeStatus': 'employee_status',
      'employee_status': 'employee_status',
      'employee_employeeType': 'employee_type',
      'reporting_manager': 'reporting_manager'
    };
    
    const modalContext = lookupFieldMap[lookupField] || lookupField;
    setLookupModalContext(modalContext);
    
    if (context === 'edit') {
      setEditingLookup(true);
      
      // Pre-populate form with selected values for edit mode
      const selectedValueMap = {
        'employee_designation': selectedDesignation,
        'employee_department': selectedDepartment,
        'employee_subDepartment': selectedSubDepartment,
        'employee_workLocation': selectedWorkLocation,
        'employee_shiftTimings': selectedShiftTimings,
        'employee_employeeStatus': selectedEmpStatus,
        'employee_status': selectedEmpStatus,
        'employee_employeeType': selectedEmployeeType,
        'reporting_manager': selectedReportingManager
      };
      
      const selectedValue = selectedValueMap[lookupField];
      
      if (selectedValue && selectedValue.name) {
        setLookupFormValue(selectedValue.name);
        setLookupDescription(selectedValue.description || '');
        setLastSelectedLookupId(selectedValue.id);
      } else {
        // Reset form data if no selection
        setLookupFormValue('');
        setLookupDescription('');
        setLastSelectedLookupId(null);
      }
    } else {
      setEditingLookup(false);
      // Reset form data for add mode
      setLookupFormValue('');
      setLookupDescription('');
      setLastSelectedLookupId(null);
    }
    
    setLookupModalVisible(true);
  };

  // Work Location work type start
  const [selectedWorkLocation, setSelectedWorkLocation] = useState(null)
  
  const [workLocationWorkTypes, setWorkLocationWorkTypes] = useState([])

  const workLocationDropdownWorkTypes = workLocationAPIData

  const handleWorkLocationWorkTypesChange = updatedWorkTypes => {
    setWorkLocationWorkTypes(updatedWorkTypes)
  }

  const handleWorkLocationSelectionChange = selectedWorkType => {
    setSelectedWorkLocation(selectedWorkType)
  }
  // Work Location work type end

  // Shift Timings work type start
  const [selectedShiftTimings, setSelectedShiftTimings] = useState(null)
  
  const [shiftTimingsWorkTypes, setShiftTimingsWorkTypes] = useState([
    {
      name: "Day Shift (9:00 AM - 6:00 PM)",
      color: "#000000",
      id: "shift-task1",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Night Shift (9:00 PM - 6:00 AM)",
      color: "#000000",
      id: "shift-task2",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Evening Shift (2:00 PM - 11:00 PM)",
      color: "#000000",
      id: "shift-task3",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Flexible Hours",
      color: "#000000",
      id: "shift-task4",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Rotational Shift",
      color: "#000000",
      id: "shift-task5",
      statuses: ["Pending", "Processing", "Completed"],
    },
  ])

  const shiftTimingsDropdownWorkTypes = shiftTimingsAPIData

  const handleShiftTimingsWorkTypesChange = updatedWorkTypes => {
    setShiftTimingsWorkTypes(updatedWorkTypes)
  }

  const handleShiftTimingsSelectionChange = selectedWorkType => {
    setSelectedShiftTimings(selectedWorkType)
  }
  // Shift Timings work type end

  // Employee Status work type start
  const [selectedEmpStatus, setSelectedEmpStatus] = useState(null)
  
  const [empStatusWorkTypes, setEmpStatusWorkTypes] = useState([
    {
      name: "Active",
      color: "#000000",
      id: "empstatus-task1",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Inactive",
      color: "#000000",
      id: "empstatus-task2",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "On Leave",
      color: "#000000",
      id: "empstatus-task3",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Probation",
      color: "#000000",
      id: "empstatus-task4",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Terminated",
      color: "#000000",
      id: "empstatus-task5",
      statuses: ["Pending", "Processing", "Completed"],
    },
  ])

  const empStatusDropdownWorkTypes = employeeStatusAPIData

  const handleEmpStatusWorkTypesChange = updatedWorkTypes => {
    setEmpStatusWorkTypes(updatedWorkTypes)
  }

  const handleEmpStatusSelectionChange = selectedWorkType => {
    setSelectedEmpStatus(selectedWorkType)
  }
  // Employee Status work type end

  // Basic Status work type start (for Basic Information)
  const [selectedBasicStatus, setSelectedBasicStatus] = useState(null)
  
  const [basicStatusWorkTypes, setBasicStatusWorkTypes] = useState([]);
  
  const basicStatusDropdownWorkTypes = [
    ...basicStatusWorkTypes,
    { id: "divider", disabled: true },
    { name: "Add Basic Status", id: "create-new-basic-status-type" },
    { name: "Edit Basic Status", id: "edit-selected-basic-status-type" },
  ]
  
  const handleBasicStatusWorkTypesChange = updatedWorkTypes => {
    setBasicStatusWorkTypes(updatedWorkTypes)
  }

  const handleBasicStatusSelectionChange = selectedWorkType => {
    setSelectedBasicStatus(selectedWorkType)
  }
  // Basic Status work type end

  // Reporting Manager work type start
  const [selectedReportingManager, setSelectedReportingManager] = useState(null)
  
  const [reportingManagerWorkTypes, setReportingManagerWorkTypes] = useState([
    {
      name: "John Smith - Project Manager",
      color: "#000000",
      id: "manager-task1",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Sarah Johnson - Team Lead",
      color: "#000000",
      id: "manager-task2",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Michael Brown - Senior Manager",
      color: "#000000",
      id: "manager-task3",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Emily Davis - Technical Lead",
      color: "#000000",
      id: "manager-task4",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "David Wilson - Department Head",
      color: "#000000",
      id: "manager-task5",
      statuses: ["Pending", "Processing", "Completed"],
    },
  ])

  const reportingManagerDropdownWorkTypes = employeesAPIData

  const handleReportingManagerWorkTypesChange = updatedWorkTypes => {
    setReportingManagerWorkTypes(updatedWorkTypes)
  }

  const handleReportingManagerSelectionChange = selectedWorkType => {
    setSelectedReportingManager(selectedWorkType)
  }
  // Reporting Manager work type end

  // Employee Type work type start
  const [selectedEmployeeType, setSelectedEmployeeType] = useState(null)
  
  const [employeeTypeWorkTypes, setEmployeeTypeWorkTypes] = useState([
    {
      name: "Full-time",
      color: "#000000",
      id: "emptype-task1",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Part-time",
      color: "#000000",
      id: "emptype-task2",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Contract",
      color: "#000000",
      id: "emptype-task3",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Intern",
      color: "#000000",
      id: "emptype-task4",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Consultant",
      color: "#000000",
      id: "emptype-task5",
      statuses: ["Pending", "Processing", "Completed"],
    },
  ])

  const employeeTypeDropdownWorkTypes = employeeTypeAPIData

  const handleEmployeeTypeWorkTypesChange = updatedWorkTypes => {
    setEmployeeTypeWorkTypes(updatedWorkTypes)
  }

  const handleEmployeeTypeSelectionChange = selectedWorkType => {
    setSelectedEmployeeType(selectedWorkType)
  }
  // Employee Type work type end

  // Sub Department work type start
  const [selectedSubDepartment, setSelectedSubDepartment] = useState(null)
  
  const [subDepartmentWorkTypes, setSubDepartmentWorkTypes] = useState([])

  const subDepartmentDropdownWorkTypes = subDepartmentAPIData

  const handleSubDepartmentWorkTypesChange = updatedWorkTypes => {
    setSubDepartmentWorkTypes(updatedWorkTypes)
  }

  const handleSubDepartmentSelectionChange = selectedWorkType => {
    setSelectedSubDepartment(selectedWorkType)
  }
  // Sub Department work type end

  
  const [jobtitle, setJobtitle] = useState("Frontend Developer");
  const [email, setEmail] = useState(null);
  const [totalExperience, setTotalExperience] = useState("2");
  const [address, setAddress] = useState("");

  const [currentSalary, setCurrentSalary] = useState("600000");
  const [expectedSalary, setExpectedSalary] = useState("800000");


  // education

  const [educationDetails, setEducationDetails] = useState([{
    degree: "Bachelor of Computer Science",
    institution: "JNTU",
    grade: "A",
    year: "2022",
  },]);
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [newEducation, setNewEducation] = useState({
    degree: '',
    institution: '',
    year: '',
    endYear: '',
    endMonth: '',
    grade: '',
  });

  // Add new education details to the table
  const handleAddEducation = () => {
    if (
      newEducation.degree.trim() &&
      newEducation.institution.trim() &&
      newEducation.year.trim() &&
      newEducation.grade.trim()
    ) {
      setEducationDetails([...educationDetails, { ...newEducation }]);
      setNewEducation({ degree: '', institution: '', year: '', grade: '' });
      setIsDialogVisible(false);
    } else {
      alert("Please fill all fields.");
    }
  };

  const years = Array.from({ length: 50 }, (_, i) => {
    const year = new Date().getFullYear() - i;
    return { label: year.toString(), value: year.toString() };
  });

  const months = [
    { label: 'January', value: 'January' },
    { label: 'February', value: 'February' },
    { label: 'March', value: 'March' },
    { label: 'April', value: 'April' },
    { label: 'May', value: 'May' },
    { label: 'June', value: 'June' },
    { label: 'July', value: 'July' },
    { label: 'August', value: 'August' },
    { label: 'September', value: 'September' },
    { label: 'October', value: 'October' },
    { label: 'November', value: 'November' },
    { label: 'December', value: 'December' },
  ];

  // system fields
  const handleUpload = async (event) => {
    const file = event.files[0];
    if (!file) return;

    // Validate required fields
    if (!selectedDocument) {
      toast.current?.show({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Please select a document type before uploading.',
        life: 3000
      });
      return;
    }

    if (!subject || subject.trim() === '') {
      toast.current?.show({
        severity: 'error',
        summary: 'Validation Error', 
        detail: 'Please enter a subject for the document before uploading.',
        life: 3000
      });
      return;
    }

    console.log("Document upload started:", {
      fileName: file.name,
      fileSize: file.size,
      fileType: file.type,
      documentType: selectedDocument,
      subject: subject,
      isEditMode,
      employeeId
    });

    setIsUploadingDocument(true);
    setDocumentFile(file);
    documentFileRef.current = file;

    try {
      // For existing employees, upload immediately
      if (isEditMode && employeeId) {
        console.log('Uploading document for existing employee:', employeeId);
        
        const documentFormData = createValidatedDocumentFormData(
          file, 
          subject,
          selectedDocument
        );
        
        console.log('Created validated FormData for document, uploading...');
        
        const result = await createEntityDocument('employees', employeeId, documentFormData);
        console.log('Document upload result:', result);
        
        if (result && (result.id || result.status === 201 || result.status_code === 201)) {
          // Refresh employee documents to show the new upload
          await refreshEmployeeDocuments();
          
          toast.current?.show({
            severity: 'success',
            summary: 'Document Uploaded',
            detail: `${selectedDocument} has been uploaded successfully!`,
            life: 3000
          });
          
          // Clear form fields after successful upload
          setSubject('');
          setSelectedDocument(null);
          setDocumentFile(null);
          documentFileRef.current = null;
          
          console.log('Document uploaded successfully:', result);
        } else {
          throw new Error('Failed to upload document - invalid response');
        }
      } else {
        // For new employees, just store the file for later upload
        console.log('Document file stored for new employee creation');
        
        // Validate file immediately even for new employees
        try {
          createValidatedDocumentFormData(file, subject, selectedDocument);
          console.log('Document file validation passed for new employee');
        } catch (validationError) {
          console.error('Document file validation failed for new employee:', validationError);
          throw validationError;
        }
        
        toast.current?.show({
          severity: 'info',
          summary: 'Document Ready',
          detail: 'Document will be uploaded when employee is saved.',
          life: 3000
        });
      }
    } catch (error) {
      console.error('Error uploading document:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Upload Failed',
        detail: error.message || 'Failed to upload document. Please try again.',
        life: 3000
      });
      
      // Clear file states on error
      setDocumentFile(null);
      documentFileRef.current = null;
    } finally {
      setIsUploadingDocument(false);
    }
  };



  //edit address
  const [visible, setVisible] = useState(false);
  const [street1, setStreet1] = useState('');
  const [street2, setStreet2] = useState(' ');
  // const [selectedCity, setSelectedCity] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [postalCode, setPostalCode] = useState('');
  const [selectedLabel, setSelectedLabel] = useState(null);

  const addCities = [
    { name: 'Hyderabad', code: 'HYD' },
    { name: 'Chennai', code: 'CHN' },
    { name: 'Mumbai', code: 'MUM' },
    { name: 'Bangalore', code: 'BLR' },
    { name: 'Delhi', code: 'DEL' },
  ]

  const addStates = [
    { name: 'Andhra Pradesh', code: 'AP' },
    { name: 'Telangana', code: 'TG' },
    { name: 'Tamil Nadu', code: 'TN' },
    { name: 'Karnataka', code: 'KA' },
    { name: 'Kerala', code: 'KL' },
  ]

  const addCountries = [
    { name: "India", code: "IN" },
    { name: "United States", code: "US" },
    { name: "Canada", code: "CA" },
    { name: "Germany", code: "DE" },
    { name: "Australia", code: "AU" },
  ]

  const labels = [
    { name: "Work from Office", code: "WORK" },
    { name: "Work from Home", code: "HOME" },
    { name: "Work from Remote", code: "REMOTE" }
  ]


  const updateAddress = () => {
    // setAddress(`${street1}  ${street2} ${postalCode}`.trim());
  };
  useEffect(() => {
    const updatedAddress = [street1, street2, selectedState?.name, selectedCity?.name, selectedCountry?.name, selectedLabel?.name, postalCode].filter(Boolean);
    setAddress(updatedAddress);
  }, [street1, street2, postalCode, selectedState, selectedCity, selectedCountry, selectedLabel, postalCode]);


  //documents popup type
  const [selectedDocument, setSelectedDocument] = useState(null);

  const groupedDocuments = [
    {
      label: 'Proof of Identity',
      items: [
        { label: 'Aadhaar Card', value: 'Aadhaar Card' },
        { label: 'Passport', value: 'Passport' },
        { label: 'Voter ID', value: 'Voter ID' },
        { label: 'PAN Card', value: 'PAN Card' },
        { label: 'Driver\'s License', value: 'Driver\'s License' }
      ]
    },
    {
      label: 'Educational Qualification Documents',
      items: [
        { label: '10th, 12th Standard Mark Sheets', value: '10th, 12th Standard Mark Sheets' },
        { label: 'Degree/Diploma Certificates', value: 'Degree/Diploma Certificates' },
        { label: 'Consolidated Mark Sheets', value: 'Consolidated Mark Sheets' },
        { label: 'Professional Certification Documents', value: 'Professional Certification Documents' }
      ]
    },
    {
      label: 'Employment-Related Documents',
      items: [
        { label: 'Offer Letter', value: 'Offer Letter' },
        { label: 'Appointment Letter', value: 'Appointment Letter' },
        { label: 'Resume/Curriculum Vitae', value: 'Resume/Curriculum Vitae' },
        { label: 'Previous Employment Experience Certificates', value: 'Previous Employment Experience Certificates' },
        { label: 'Relieving Letters from Previous Employers', value: 'Relieving Letters from Previous Employers' },
        { label: 'Service Certificate', value: 'Service Certificate' },
        { label: 'Last Drawn Salary Slip', value: 'Last Drawn Salary Slip' }
      ]
    },
    {
      label: 'Contact and Address Proof',
      items: [
        { label: 'Permanent Address Proof', value: 'Permanent Address Proof' },
        { label: 'Current Residential Address Proof', value: 'Current Residential Address Proof' },
        { label: 'Local Address Proof', value: 'Local Address Proof' },
        { label: 'Address Verification Documents', value: 'Address Verification Documents' },
        { label: 'Contact Information Form', value: 'Contact Information Form' }
      ]
    },
    {
      label: 'Financial and Tax-Related Documents',
      items: [
        { label: 'PAN Card', value: 'PAN Card' },
        { label: 'Bank Account Details', value: 'Bank Account Details' },
        { label: 'Cancelled Cheque', value: 'Cancelled Cheque' },
        { label: 'Form 16 from Previous Employer', value: 'Form 16 from Previous Employer' },
        { label: 'Tax Identification Documents', value: 'Tax Identification Documents' }
      ]
    },
    {
      label: 'Personal and Medical Documents',
      items: [
        { label: 'Passport-Size Photographs', value: 'Passport-Size Photographs' },
        { label: 'Birth Certificate', value: 'Birth Certificate' },
        { label: 'Marriage Certificate (if applicable)', value: 'Marriage Certificate (if applicable)' },
        { label: 'Passport Details', value: 'Passport Details' },
        { label: 'Medical Fitness Certificate', value: 'Medical Fitness Certificate' },
        { label: 'Police Verification Certificate', value: 'Police Verification Certificate' }
      ]
    },
    {
      label: 'Legal and Compliance Documents',
      items: [
        { label: 'Background Verification Consent Form', value: 'Background Verification Consent Form' },
        { label: 'Non-Disclosure Agreement (NDA)', value: 'Non-Disclosure Agreement (NDA)' },
        { label: 'Employment Bond (if applicable)', value: 'Employment Bond (if applicable)' },
        { label: 'Declaration of No Criminal Record', value: 'Declaration of No Criminal Record' }
      ]
    },
    {
      label: 'Statutory Documentation',
      items: [
        { label: 'Employee Provident Fund (EPF) Registration Form', value: 'Employee Provident Fund (EPF) Registration Form' },
        { label: 'Employee State Insurance (ESI) Form', value: 'Employee State Insurance (ESI) Form' },
        { label: 'Professional Tax Registration Details', value: 'Professional Tax Registration Details' }
      ]
    },
    {
      label: 'Emergency Contact and Nominee Details',
      items: [
        { label: 'Emergency Contact Information Form', value: 'Emergency Contact Information Form' },
        { label: 'Nominee Details for Insurance and Other Benefits', value: 'Nominee Details for Insurance and Other Benefits' },
        { label: 'Personal References', value: 'Personal References' }
      ]
    },
    {
      label: 'Additional Specialized Documents (Depending on Role/Industry)',
      items: [
        { label: 'Professional License Certificates', value: 'Professional License Certificates' },
        { label: 'Specialized Skill Certification', value: 'Specialized Skill Certification' },
        { label: 'Work Permit/Visa Documents (for Foreign Nationals)', value: 'Work Permit/Visa Documents (for Foreign Nationals)' },
        { label: 'Security Clearance Certificates', value: 'Security Clearance Certificates' }
      ]
    }
  ];

  const groupedItemTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <i className="pi pi-file mr-2"></i>
        <div>{option.label}</div>
      </div>
    );
  };

  // categories

  const [categories] = useState([
    {
      key: "0",
      label: "Skills",
      children: [
        {
          key: "0-0",
          label: "Frontend",
          children: [
            { key: "0-0-0", label: "React" },
            { key: "0-0-1", label: "Angular" },
            { key: "0-0-2", label: "Bootstrap" },
          ],
        },
        {
          key: "0-1",
          label: "Backend",
          children: [
            { key: "0-1-0", label: "Python" },
            { key: "0-1-1", label: "Java" },
            { key: "0-1-2", label: "C#" },
          ],
        },
        {
          key: "0-2",
          label: "QA",
          children: [
            { key: "0-2-0", label: "Manual" },
            { key: "0-2-1", label: "Automation" },
          ],
        },
      ],
    },
  ]);

  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null);

  //groups

  const [groups] = useState([
    {
      key: "0",
      label: "Skills",
      children: [
        {
          key: "0-0",
          label: "Frontend",
          children: [
            { key: "0-0-0", label: "React" },
            { key: "0-0-1", label: "Angular" },
            { key: "0-0-2", label: "Bootstrap" },
          ],
        },
        {
          key: "0-1",
          label: "Backend",
          children: [
            { key: "0-1-0", label: "Python" },
            { key: "0-1-1", label: "Java" },
            { key: "0-1-2", label: "C#" },
          ],
        },
        {
          key: "0-2",
          label: "QA",
          children: [
            { key: "0-2-0", label: "Manual" },
            { key: "0-2-1", label: "Automation" },
          ],
        },
      ],
    },
  ]);

  const [selectedGroupKey, setSelectedGroupKey] = useState(null);

  const setstatus = [
    { name: "Active", code: "act" },
    { name: "Inactive", code: "inc" },
  ]

  const [primarySkills, setPrimarySkills] = useState(null);
  const primary = [
    { name: 'JavaScript' },
    { name: 'React' },
    { name: 'Node.js' },
    { name: 'CSS' }
  ];


  const [secondarySkills, setSecondarySkills] = useState([]);
  const secondary = [
    { name: 'SQL' },
    { name: 'Python' },
    { name: 'Java' },
    { name: 'PHP' }
  ];

  const [otherSkills, setOtherSkills] = useState([]);
  const other = [
    { name: 'Git' },
    { name: 'Docker' },
    { name: 'Kubernetes' },
    { name: 'AWS' }
  ];

  const [skillsOptions, setSkillsOptions] = useState([
    { value: "java", label: "Java" },
    { value: "react", label: "React" },
    { value: "nodejs", label: "Node.js" },
    // Add more skill options as needed
  ]);

  const [selectedPrimarySkills, setSelectedPrimarySkills] = useState([]);
  console.log("Selected Primary Skills:", selectedPrimarySkills);
  
  // Handle Primary Skills Selection
  const handlePrimarySkillsChange = (selectedOptions) => {
    console.log("Primary skills changed:", selectedOptions);
    const skillIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
    console.log("Setting selectedPrimarySkills to:", skillIds);
    // setSelectedPrimarySkills(skillIds);
  };

  // Handle Secondary Skills Selection
  const handleSecondarySkillsChange = (selectedOptions) => {
    console.log("Secondary skills changed:", selectedOptions);
    const skillIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
    console.log("Setting secondarySkills to:", skillIds);
    setSecondarySkills(skillIds);
  };

  // Handle Other Skills Selection
  const handleOtherSkillsChange = (selectedOptions) => {
    console.log("Other skills changed:", selectedOptions);
    const skillIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
    console.log("Setting otherSkills to:", skillIds);
    setOtherSkills(skillIds);
  };

  // Templates for Dropdown items
  const skillOptionTemplate = (option) => {
    return <div>{option.name}</div>;
  };


  const customBase64Uploader = async (event) => {
    // convert file to base64 encoded
    const file = event.files[0];
    const reader = new FileReader();
    let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url

    reader.readAsDataURL(blob);

    reader.onloadend = function () {
      const base64data = reader.result;
    };
  };


  const [dateAvalibility, setDateAvalibility] = useState(null);
  const [dob, setDob] = useState(null);
  const [dateOfJoining, setDateOfJoining] = useState(null);


  const [EmployeeRec, setEmployeeRec] = useState("  ")

  //  work experience variables start

  const [workExperiences, setWorkExperiences] = useState([{
    company: "Varun Digital Media",
    jobTitle: "Frotend Developoer",
    fromDate: new Date(2023, 2, 15),
    toDate: new Date(2025, 1, 21),
  }]);
  const [showDialog, setShowDialog] = useState(false);
  const [formValues, setFormValues] = useState({
    company: "",
    website: "",
    jobTitle: "",
    fromDate: null,
    toDate: null,
    description: "",
  });
  const [editIndex, setEditIndex] = useState(null);

  // Form Handlers
  const handleInputChange = (key, value) => {
    setFormValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSave = () => {
    if (editIndex !== null) {
      // Update existing record
      const updatedExperiences = [...workExperiences];
      updatedExperiences[editIndex] = formValues;
      setWorkExperiences(updatedExperiences);
      setEditIndex(null);
    } else {
      // Add new record
      setWorkExperiences([...workExperiences, formValues]);
    }
    setFormValues({
      company: "",
      website: "",
      jobTitle: "",
      fromDate: null,
      toDate: null,
      description: "",
    });
    setShowDialog(false);
  };




  // Table Action Buttons
  const actionBodyTemplate = (rowData, column) => {
    const index = column.rowIndex;
    return (
      <div className="d-flex">
        <Button className="trashbtn mr-1" onClick={() => handleEdit(rowData, index)}>
          <i className="pi pi-pencil"></i>
        </Button>
        <Button className="trashbtn p-0" onClick={() => handleDelete(index)}>
          <i className="pi pi-trash"></i>
        </Button>
      </div>
    );
  };


  //  work experience variables end




  // Documents variable start


  const [selectedStatus1, setSelectedStatus1] = useState(null);  // Renamed to setSelectedStatus1
  const [subject, setSubject] = useState('');
  const [file, setFile] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [displayDialog, setDisplayDialog] = useState(false); 
  // Sample status options (Renamed to setstatus1)
  const setstatus1 = [
    { name: 'Draft', code: 'draft' },
    { name: 'Final', code: 'final' },
    { name: 'Archived', code: 'archived' },
  ];

  // Custom uploader function (Renamed to customBase64Uploader2)
  const customBase64Uploader2 = (event) => {
    setFile(event.files[0]);
  };
    const [uploadedFiles, setUploadedFiles] = useState([]);
const getDocuments = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/employees/${employeeId}/documents/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                setDocuments(response.data.data);
            }
        } catch (err) {
            console.log(err);

        }
    }
useEffect(() => {
        getDocuments();
    }, [employeeId])
  // Handle Add Document
 const handleAddDocument = async () => {
        try {
            const formData = new FormData();
            formData.append('type', selectedDocument || '');
            formData.append('description', subject || '');
            if (uploadedFiles instanceof File) {
                formData.append('uploaded_files', uploadedFiles);
            }
            else if (Array.isArray(uploadedFiles)) {
                uploadedFiles.forEach((file, idx) => {
                    formData.append('uploaded_files', file); 
                });
            }

            const response = await axios.post(
                `${process.env.REACT_APP_Company_Contact}/company/employees/${employeeId}/documents/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );


            if (response.status === 201) {
                console.log('Document added successfully:', response.data);
                // setDocuments(prev => [...prev, response.data.data]); 
                getEntityDocuments('employees', employeeId);
                getDocuments();
                refreshEmployeeDocuments();
                setDisplayDialog(false);
                setSelectedDocument(null);
                setSubject('');
                setFile(null);
            }
        } catch (error) {
            console.error('Error adding document:', error);
        }
    };

  // Open the modal to add a new document
  const openAddDocumentDialog = () => {
    setDisplayDialog(true);
  };

  // Close the modal
  const closeAddDocumentDialog = () => {
    setDisplayDialog(false);
  };


  // Documents variable end

  // Resume document state variables - using Companies pattern
  const [resumeFile, setResumeFile] = useState(null);
  const [resumeDocumentId, setResumeDocumentId] = useState(null);
  const [isUploadingResume, setIsUploadingResume] = useState(false);
  const [employeeDocuments, setEmployeeDocuments] = useState([]);
  console.log("Employee documents state:", employeeDocuments);
  
  // Use ref to store actual File objects to prevent serialization issues (like in Companies)
  const resumeFileRef = useRef(null);

  // Document upload state variables - similar to Resume pattern
  const [documentFile, setDocumentFile] = useState(null);
  const [isUploadingDocument, setIsUploadingDocument] = useState(false);
  const documentFileRef = useRef(null);

  // Function to refresh employee documents
  const refreshEmployeeDocuments = async () => {
    if (!employeeId) {
      console.log('No employee ID provided, skipping document refresh');
      return;
    }
    
    try {
      console.log('Refreshing employee documents for employee ID:', employeeId);
      const response = await getEntityDocuments('employees', employeeId);
      console.log('Employee documents API response:', response);
      
      // Handle different response formats
      let documentsData;
      if (Array.isArray(response)) {
        documentsData = response;
      } else if (response && response.data && Array.isArray(response.data)) {
        documentsData = response.data;
      } else if (response && response.results && Array.isArray(response.results)) {
        documentsData = response.results;
      } else {
        documentsData = [];
        console.warn('Unexpected documents response format:', response);
      }
      const transformedEmployeeDocuments = employeeDocuments.map(doc => ({
        id: doc.id,
        type: "General", 
        name: doc.description || "Document",
        description: doc.description || "",
        file: doc.file,
        file_size: null, 
        created_at: doc.created_at,
        updated_at: doc.updated_at
      }));

      setEmployeeDocuments(documentsData);
      // setDocuments(employeeDocuments); // Also update general documents state
      console.log('Employee documents refreshed, count:', transformedEmployeeDocuments, 'documents:', documentsData);
    } catch (error) {
      console.error('Error refreshing employee documents:', error);
      // setEmployeeDocuments([]); // Set empty array on error
    }
  };
 
  // Helper function to create and validate FormData (adapted from Companies)
  const createValidatedResumeFormData = (file, description) => {
    console.log("Creating FormData for resume file:", file);
    console.log("Resume file validation check:");
    console.log("- instanceof File:", file instanceof File);
    console.log("- file.name:", file.name);
    console.log("- file.size:", file.size);
    console.log("- file.type:", file.type);
    console.log("- file.lastModified:", file.lastModified);
    console.log("- file constructor:", file.constructor.name);
    
    if (!(file instanceof File)) {
      // Try to recover if it's a File-like object
      if (file && file.name && file.size !== undefined && file.type !== undefined) {
        console.warn("Resume file object appears corrupted, attempting to reconstruct...");
        try {
          const blob = new Blob([file], { type: file.type });
          const newFile = new File([blob], file.name, { 
            type: file.type,
            lastModified: file.lastModified || Date.now()
          });
          console.log("Reconstructed resume file:", newFile);
          file = newFile;
        } catch (reconstructError) {
          console.error("Failed to reconstruct resume file:", reconstructError);
          throw new Error(`Invalid resume file object - not an instance of File: ${typeof file}`);
        }
      } else {
        throw new Error(`Invalid resume file object - not an instance of File: ${typeof file}`);
      }
    }
    
    if (!file.name) {
      throw new Error("Resume file has no name");
    }
    
    if (file.size === 0) {
      throw new Error("Resume file is empty");
    }
    
    console.log("Resume file validation passed, creating FormData...");
    
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('name', file.name);
    formData.append('description', description || `Resume for employee - ${file.name}`);
    formData.append('type', 'Resume');
    
    // Test FormData retrieval
    const testFile = formData.get('file');
    if (!(testFile instanceof File)) {
      console.error("FormData validation failed - retrieved file is not a File instance:", testFile);
      throw new Error("FormData creation failed - file not properly stored");
    }
    
    console.log("Resume FormData created and validated successfully");
    return formData;
  };

  // Document upload FormData creation - adapted from Resume pattern
  const createValidatedDocumentFormData = (file, description, documentType) => {
    console.log("Creating FormData for document file:", file);
    console.log("Document file validation check:");
    console.log("- instanceof File:", file instanceof File);
    console.log("- file.name:", file.name);
    console.log("- file.size:", file.size);
    console.log("- file.type:", file.type);
    console.log("- file.lastModified:", file.lastModified);
    console.log("- file constructor:", file.constructor.name);
    
    if (!(file instanceof File)) {
      // Try to recover if it's a File-like object
      if (file && file.name && file.size !== undefined && file.type !== undefined) {
        console.warn("Document file object appears corrupted, attempting to reconstruct...");
        try {
          const blob = new Blob([file], { type: file.type });
          const newFile = new File([blob], file.name, { 
            type: file.type,
            lastModified: file.lastModified || Date.now()
          });
          console.log("Reconstructed document file:", newFile);
          file = newFile;
        } catch (reconstructError) {
          console.error("Failed to reconstruct document file:", reconstructError);
          throw new Error(`Invalid document file object - not an instance of File: ${typeof file}`);
        }
      } else {
        throw new Error(`Invalid document file object - not an instance of File: ${typeof file}`);
      }
    }
    
    if (!file.name) {
      throw new Error("Document file has no name");
    }
    
    if (file.size === 0) {
      throw new Error("Document file is empty");
    }
    
    console.log("Document file validation passed, creating FormData...");
    
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('name', file.name);
    formData.append('description', description || `Document for employee - ${file.name}`);
    formData.append('type', documentType || 'Document');
    
    // Test FormData retrieval
    const testFile = formData.get('file');
    if (!(testFile instanceof File)) {
      console.error("FormData validation failed - retrieved file is not a File instance:", testFile);
      throw new Error("FormData creation failed - file not properly stored");
    }
    
    console.log("Document FormData created and validated successfully");
    return formData;
  };

  // Resume upload handler - adapted from Companies pattern
  const handleResumeUpload = async (event) => {
    const file = event.files[0];
    if (!file) return;

    console.log("Resume upload started:", {
      fileName: file.name,
      fileSize: file.size,
      fileType: file.type,
      isEditMode,
      employeeId
    });

    setIsUploadingResume(true);
    setResumeFile(file);
    resumeFileRef.current = file; // Store in ref like Companies pattern

    try {
      // For existing employees, upload immediately
      if (isEditMode && employeeId) {
        console.log('Uploading resume for existing employee:', employeeId);
        
        // Use validated FormData creation like Companies
        const documentFormData = createValidatedResumeFormData(
          file, 
          `Resume for employee - ${file.name}`
        );
        
        console.log('Created validated FormData for resume, uploading...');
        
        const result = await createEntityDocument('employees', employeeId, documentFormData);
        console.log('Resume upload result:', result);
        
        if (result && (result.id || result.status === 201 || result.status_code === 201)) {
          const documentId = result.id;
          setResumeDocumentId(documentId);
          
          // Update employee record with the resume document ID
          try {
            console.log('Updating employee record with resume document ID:', documentId);
            const updatePayload = { resume: documentId };
            const updateResult = await updateEmployee(employeeId, updatePayload);
            console.log('Employee record updated with resume ID:', updateResult);
            
            // Refresh employee documents to show the new upload
            await refreshEmployeeDocuments();
            
            toast.current?.show({
              severity: 'success',
              summary: 'Resume Uploaded',
              detail: 'Resume has been uploaded and linked to employee successfully!',
              life: 3000
            });
            
            console.log('Resume uploaded and linked to employee successfully:', result);
          } catch (updateError) {
            console.error('Error updating employee with resume ID:', updateError);
            // Resume was uploaded but linking failed
            await refreshEmployeeDocuments();
            
            toast.current?.show({
              severity: 'warn',
              summary: 'Resume Uploaded',
              detail: 'Resume uploaded but failed to link to employee record. You may need to reload the page.',
              life: 5000
            });
          }
        } else {
          throw new Error('Failed to upload resume - invalid response');
        }
      } else {
        // For new employees, just store the file for later upload
        console.log('Resume file stored for new employee creation');
        
        // Validate file immediately even for new employees
        try {
          createValidatedResumeFormData(file, `Resume for new employee - ${file.name}`);
          console.log('Resume file validation passed for new employee');
        } catch (validationError) {
          console.error('Resume file validation failed for new employee:', validationError);
          throw validationError;
        }
        
        toast.current?.show({
          severity: 'info',
          summary: 'Resume Ready',
          detail: 'Resume will be uploaded when employee is saved.',
          life: 3000
        });
      }
    } catch (error) {
      console.error('Error uploading resume:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Upload Failed',
        detail: error.message || 'Failed to upload resume. Please try again.',
        life: 3000
      });
      
      // Clear file states on error
      setResumeFile(null);
      resumeFileRef.current = null;
    } finally {
      setIsUploadingResume(false);
    }
  };

  // Data loading functions
  const loadEmployeeData = async () => {
    if (!employeeId) return;
    
    setIsLoading(true);
    try {
      const response = await getEmployee(employeeId);
      console.log("Loaded employee data:", response);
      
      setEmployeeData(response);
      
      // Populate form fields
      setFormData({
        first_name: response.first_name || "",
        last_name: response.last_name || "",
        primary_email: response.primary_email || "",
        secondary_email: response.secondary_email || "",
        personal_phone: response.personal_phone || "",
        office_phone: response.office_phone || "",
        designation: response.designation || "",
        company: response.company || null,
        date_of_joining: response.date_of_joining ? new Date(response.date_of_joining) : null,
        work_location: response.work_location || "",
        primary_skills: response.primary_skills || [],
        secondary_skills: response.secondary_skills || "",
        other_skills: response.other_skills || "",
        address: response.address || ""
      });
      
      // Set form values using react-hook-form
      setValue("firstname", response.first_name || "");
      setValue("lastname", response.last_name || "");
      setValue("personal_email", response.primary_email || "");
      setValue("Email2", response.secondary_email || "");
      setValue("phone", response.personal_phone || "");
      setValue("office_phone", response.office_phone || "");
      setValue("Designation", response.designation || "");
      setValue("Availability", response.date_of_joining ? new Date(response.date_of_joining) : null);
      setcreatedBy(response.created_by_name || "");
      seteditedBy(response.updated_by_name|| "");
      // Set the dateOfJoining state as well (used by the Calendar component)
      setDateOfJoining(response.date_of_joining ? new Date(response.date_of_joining) : null);
      
      // Set additional form fields
      setFullname(`${response.first_name || ""} ${response.last_name || ""}`.trim());
      setAddress(response.address || ""); // Set address state
      setTotalExperience(response.total_experience || "0"); // Set total experience
      setPrivateDrop(response.is_private || false);
      setPrivetDropdown(response.private_user_ids || []);
      // Set skills states - convert comma-separated strings back to arrays if needed
      console.log("Raw employee skills data:", {
        primary_skills: response.primary_skills,
        secondary_skills: response.secondary_skills,
        other_skills: response.other_skills
      });

      if (response.primary_skills) {
        // Convert string "React,Javascrpip" -> ["React", "Javascrpip"]
        const primarySkillsArray =
          typeof response.primary_skills === "string"
            ? response.primary_skills
              .split(",")
              .map((skill) => skill.trim())
              .filter((skill) => skill) // remove empty values
            : Array.isArray(response.primary_skills)
              ? response.primary_skills
              : [];

        // Set into state for Chips
        setPrimarySkills(primarySkillsArray);
        setSelectedPrimarySkills(primarySkillsArray);
      }

      if (response.secondary_skills) {
        const secondaryArray = typeof response.secondary_skills === "string"
          ? response.secondary_skills.split(",").map(s => s.trim()).filter(Boolean)
          : Array.isArray(response.secondary_skills)
            ? response.secondary_skills
            : [];
        setSecondarySkills(secondaryArray);
      }

      if (response.other_skills) {
        const otherArray = typeof response.other_skills === "string"
          ? response.other_skills.split(",").map(s => s.trim()).filter(Boolean)
          : Array.isArray(response.other_skills)
            ? response.other_skills
            : [];
        setOtherSkills(otherArray);
      }

      // Set work location if available
      if (response.work_location) {
        // We'll need to find the matching work location object when workLocationAPIData is loaded
        // For now, just store the value
        setSelectedWorkLocation({ name: response.work_location, id: response.work_location });
      }
      
      // Set company selection if available
      if (response.company_data) {
        const companyData = {
          name: response.company_data.name,
          id: response.company_data.id,
          __original: response.company_data
        };
        setSelectedModule(companyData);
      } else if (response.company || response.company_name) {
        // API may return company id and company_name fields instead of nested company_data
        setSelectedModule({ name: response.company_name || String(response.company), id: String(response.company), __original: { id: response.company, name: response.company_name } });
      }

      // Set designation selection if available
      if (response.designation_data) {
        const designationData = {
          name: response.designation_data.value || response.designation_data.name || response.designation_data.label,
          id: response.designation_data.id,
          __original: response.designation_data
        };
        setSelectedDesignation(designationData);
      } else if (response.designation) {
        // If only designation id is provided, try to set a minimal object
        setSelectedDesignation({ name: String(response.designation), id: String(response.designation) });
      }

      // Set reporting manager (handle null values too)
      // Store the reporting manager ID - we'll match it with the full object when employeesAPIData loads
      setEmployeeData(prevData => ({ ...prevData, reportingManager: response.reporting_manager }));

      // Set department (handle null values too)
      // Store the department ID - we'll match it with the full object when departmentWorkTypes loads
      setEmployeeData(prevData => ({ ...prevData, department: response.department }));
      
      if (response.department) {
        // Also try to set selectedDepartment if departmentWorkTypes is already loaded
        if (departmentWorkTypes && departmentWorkTypes.length > 0) {
          const foundDepartment = departmentWorkTypes.find(dept => 
            String(dept.id) === String(response.department) || 
            String(dept.__original?.id) === String(response.department) || 
            String(dept.__original?.value) === String(response.department)
          );
          if (foundDepartment) setSelectedDepartment(foundDepartment);
        }
      }

      // Set sub department (handle null values too)
      // Store the sub department ID - we'll match it with the full object when subDepartmentAPIData loads
      setEmployeeData(prevData => ({ ...prevData, subDepartment: response.sub_department }));
      
      if (response.sub_department) {
        // Also try to set selectedSubDepartment if subDepartmentAPIData is already loaded
        if (subDepartmentAPIData && subDepartmentAPIData.length > 0) {
          const foundSubDepartment = subDepartmentAPIData.find(subDept => 
            String(subDept.id) === String(response.sub_department) || 
            String(subDept.__original?.id) === String(response.sub_department) || 
            String(subDept.__original?.value) === String(response.sub_department)
          );
          if (foundSubDepartment) setSelectedSubDepartment(foundSubDepartment);
        }
      }

      // Set employee type (handle null values too)
      // Store the employee type ID - we'll match it with the full object when employeeTypeAPIData loads
      setEmployeeData(prevData => ({ ...prevData, employee_type: response.employee_type }));
      
      if (response.employee_type) {
        // Also try to set selectedEmployeeType if employeeTypeAPIData is already loaded
        if (employeeTypeAPIData && employeeTypeAPIData.length > 0) {
          const foundEmployeeType = employeeTypeAPIData.find(empType => 
            String(empType.id) === String(response.employee_type) || 
            String(empType.__original?.id) === String(response.employee_type) || 
            String(empType.__original?.value) === String(response.employee_type)
          );
          if (foundEmployeeType) setSelectedEmployeeType(foundEmployeeType);
        }
      }

      // Set shift timings (handle null values too)
      // Store the shift timings ID - we'll match it with the full object when shiftTimingsAPIData loads
      setEmployeeData(prevData => ({ ...prevData, shift_timings: response.shift_timings }));
      
      if (response.shift_timings) {
        // Also try to set selectedShiftTimings if shiftTimingsAPIData is already loaded
        if (shiftTimingsAPIData && shiftTimingsAPIData.length > 0) {
          const foundShiftTimings = shiftTimingsAPIData.find(shift => 
            String(shift.id) === String(response.shift_timings) || 
            String(shift.__original?.id) === String(response.shift_timings) || 
            String(shift.__original?.value) === String(response.shift_timings)
          );
          if (foundShiftTimings) setSelectedShiftTimings(foundShiftTimings);
        }
      }

      // Set employee status for Basic Information (handle null values too)
      // Store the basic status ID - we'll match it with the full object when basicStatusAPIData loads
      setEmployeeData(prevData => ({ ...prevData, employee_status: response.employee_status }));
      
      if (response.employee_status) {
        // Also try to set selectedBasicStatus if basicStatusAPIData is already loaded
        if (basicStatusAPIData && basicStatusAPIData.length > 0) {
          const foundBasicStatus = basicStatusAPIData.find(bs => 
            String(bs.id) === String(response.employee_status) || 
            String(bs.__original?.id) === String(response.employee_status) || 
            String(bs.__original?.value) === String(response.employee_status)
          );
          if (foundBasicStatus) setSelectedBasicStatus(foundBasicStatus);
        }
      }

      // Set employee status for General Information if available (from employeeStatus field)
      if (response.employeeStatus) {
        // Store the employee status ID - we'll match it with the full object when employeeStatusAPIData loads
        setEmployeeData(prevData => ({ ...prevData, employeeStatus: response.employeeStatus }));
        
        // Also try to set selectedEmpStatus if employeeStatusAPIData is already loaded
        if (employeeStatusAPIData && employeeStatusAPIData.length > 0) {
          const foundEmpStatus = employeeStatusAPIData.find(es => 
            String(es.id) === String(response.employeeStatus) || 
            String(es.__original?.id) === String(response.employeeStatus) || 
            String(es.__original?.value) === String(response.employeeStatus)
          );
          if (foundEmpStatus) setSelectedEmpStatus(foundEmpStatus);
        }
      }

      // If designationWorkTypes already loaded, try to replace minimal selection with full object
      if (designationWorkTypes && (response.designation || response.designation_data)) {
        const desId = response.designation_data?.id ?? response.designation;
        const foundDes = designationWorkTypes.find(d => String(d.id) === String(desId) || String(d.__original?.id) === String(desId) || String(d.__original?.value) === String(desId));
        if (foundDes) setSelectedDesignation(foundDes);
      }
      
      // Load resume document ID if available (field is 'resume' in API response)
      if (response.resume) {
        setResumeDocumentId(response.resume);
        console.log("Loaded existing resume document ID:", response.resume);
      } else if (response.resume_document_id) {
        // Fallback for older field name
        setResumeDocumentId(response.resume_document_id);
        console.log("Loaded existing resume document ID (fallback):", response.resume_document_id);
      }
      
      // Load employee documents
      await refreshEmployeeDocuments();
      
      toast.current?.show({ 
        severity: 'success', 
        summary: 'Success', 
        detail: 'Employee data loaded successfully' 
      });
      
    } catch (error) {
      console.error("Error loading employee data:", error);
      toast.current?.show({ 
        severity: 'error', 
        summary: 'Error', 
        detail: 'Failed to load employee data' 
      });
    } finally {
      setIsLoading(false);
    }
  };

  const loadCompanyData = async () => {
    try {
      console.log("Loading companies from database...");
      const response = await getCompanies();
      
      if (response && response.results) {
        const transformedCompanies = response.results.map((company) => ({
          name: company.name || company.company_name,
          color: "#000000",
          id: String(company.id),
          statuses: ["Pending", "Processing", "Completed"],
          __original: company
        }));
        
        console.log("Transformed companies:", transformedCompanies);
        setModuleWorkTypes(transformedCompanies);

        // If we already have selectedModule as an id (from employee data), set the selectedModule object
        if (employeeData && employeeData.company) {
          const found = transformedCompanies.find(c => String(c.id) === String(employeeData.company));
          if (found) setSelectedModule(found);
        }
      }
    } catch (error) {
      console.error("Error loading companies:", error);
    }
  };

  const loadDesignationData = async () => {
    try {
      console.log("Loading designations from database...");
      const response = await getLookupsByName("employee_designation");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No designation items found in lookup response:', response);
        return;
      }

      const transformedDesignations = rawItems.map((designation, index) => ({
        name: designation.value || designation.name || designation.label || String(designation.id) || `Designation ${index}`,
        color: "#000000",
        id: String(designation.id ?? designation.value ?? designation.key ?? index),
        statuses: ["Active", "Available", "Assigned"],
        __original: designation
      }));

      console.log("Transformed designations:", transformedDesignations);
      setDesignationWorkTypes([...transformedDesignations]);

      // If we already have selectedDesignation as an id (from employee data), set the selectedDesignation object
      if (employeeData && employeeData.designation) {
        const found = transformedDesignations.find(d => String(d.id) === String(employeeData.designation) || String(d.__original?.id) === String(employeeData.designation) || String(d.__original?.value) === String(employeeData.designation));
        if (found) setSelectedDesignation(found);
      }
    } catch (error) {
      console.error("Error loading designations:", error);
    }
  };

  const loadDepartmentData = async () => {
    try {
      console.log("Loading departments from database...");
      const response = await getLookupsByName("employee_department");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No department items found in lookup response:', response);
        return;
      }

      const transformedDepartments = rawItems.map((department, index) => ({
        name: department.value || department.name || department.label || String(department.id) || `Department ${index}`,
        color: "#000000",
        id: String(department.id ?? department.value ?? department.key ?? index),
        statuses: ["Active", "Available", "Assigned"],
        __original: department
      }));

      console.log("Transformed departments:", transformedDepartments);
      setDepartmentWorkTypes([...transformedDepartments]);

      // If we already have selectedDepartment as an id (from employee data), set the selectedDepartment object
      if (employeeData && employeeData.department) {
        const found = transformedDepartments.find(d => String(d.id) === String(employeeData.department) || String(d.__original?.id) === String(employeeData.department) || String(d.__original?.value) === String(employeeData.department));
        if (found) setSelectedDepartment(found);
      }
    } catch (error) {
      console.error("Error loading departments:", error);
    }
  };

  const loadWorkLocationData = async () => {
    try {
      console.log("Loading work locations from database...");
      const response = await getLookupsByName("employee_workLocation");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No work location items found in lookup response:', response);
        return;
      }

      const transformedWorkLocations = rawItems.map((workLocation, index) => ({
        name: workLocation.value || workLocation.name || workLocation.label || String(workLocation.id) || `Work Location ${index}`,
        color: "#000000",
        id: String(workLocation.id ?? workLocation.value ?? workLocation.key ?? index),
        statuses: ["Active", "Available", "Assigned"],
        __original: workLocation
      }));

      console.log("Transformed work locations:", transformedWorkLocations);
      setWorkLocationAPIData([...transformedWorkLocations]);

      // If we already have selectedWorkLocation as an id (from employee data), set the selectedWorkLocation object
      if (employeeData && (employeeData.workLocation || employeeData.work_location)) {
        const workLocationValue = employeeData.workLocation || employeeData.work_location;
        const found = transformedWorkLocations.find(wl => 
          String(wl.id) === String(workLocationValue) || 
          String(wl.__original?.id) === String(workLocationValue) || 
          String(wl.__original?.value) === String(workLocationValue) ||
          String(wl.name) === String(workLocationValue)
        );
        if (found) setSelectedWorkLocation(found);
      }
    } catch (error) {
      console.error("Error loading work locations:", error);
    }
  };

  const loadShiftTimingsData = async () => {
    try {
      console.log("Loading shift timings from database...");
      const response = await getLookupsByName("employee_shiftTimings");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No shift timing items found in lookup response:', response);
        return;
      }

      const transformedShiftTimings = rawItems.map((shiftTiming, index) => ({
        name: shiftTiming.value || shiftTiming.name || shiftTiming.label || String(shiftTiming.id) || `Shift Timing ${index}`,
        color: "#000000",
        id: String(shiftTiming.id ?? shiftTiming.value ?? shiftTiming.key ?? index),
        statuses: ["Active", "Available", "Assigned"],
        __original: shiftTiming
      }));

      console.log("Transformed shift timings:", transformedShiftTimings);
      setShiftTimingsAPIData([...transformedShiftTimings]);

      // If we already have selectedShiftTimings as an id (from employee data), set the selectedShiftTimings object
      if (employeeData && employeeData.shiftTimings) {
        const found = transformedShiftTimings.find(st => String(st.id) === String(employeeData.shiftTimings) || String(st.__original?.id) === String(employeeData.shiftTimings) || String(st.__original?.value) === String(employeeData.shiftTimings));
        if (found) setSelectedShiftTimings(found);
      }
    } catch (error) {
      console.error("Error loading shift timings:", error);
    }
  };

  const loadEmployeeStatusData = async () => {
    try {
      console.log("Loading employee status from database...");
      const response = await getLookupsByName("employee_employeeStatus");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No employee status items found in lookup response:', response);
        return;
      }

      const transformedEmployeeStatus = rawItems.map((empStatus, index) => ({
        name: empStatus.value || empStatus.name || empStatus.label || String(empStatus.id) || `Employee Status ${index}`,
        color: "#000000",
        id: String(empStatus.id ?? empStatus.value ?? empStatus.key ?? index),
        statuses: ["Active", "Available", "Assigned"],
        __original: empStatus
      }));

      console.log("Transformed employee status:", transformedEmployeeStatus);
      setEmployeeStatusAPIData(transformedEmployeeStatus);

      // If we already have selectedEmpStatus as an id (from employee data), set the selectedEmpStatus object
      if (employeeData && employeeData.employeeStatus) {
        const found = transformedEmployeeStatus.find(es => String(es.id) === String(employeeData.employeeStatus) || String(es.__original?.id) === String(employeeData.employeeStatus) || String(es.__original?.value) === String(employeeData.employeeStatus));
        if (found) setSelectedEmpStatus(found);
      }
    } catch (error) {
      console.error("Error loading employee status:", error);
    }
  };

  // Function to load basic status data for Basic Information section
  const loadBasicStatusData = async () => {
    try {
      console.log("Loading basic status from database...");
      const response = await getLookupsByName("employee_status");
      console.log("Basic status API response:", response);
      
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (response.data && Array.isArray(response.data)) rawItems = response.data;
        else if (response.data && Array.isArray(response.data.results)) rawItems = response.data.results;
        else {
          console.warn("Unexpected basic status response format:", response);
          rawItems = [];
        }
      }

      console.log("Raw basic status items:", rawItems);

      const transformedBasicStatus = rawItems.map((basicStatus, index) => ({
        name: basicStatus.value || basicStatus.name || basicStatus.label || String(basicStatus.id) || `Basic Status ${index}`,
        color: "#000000",
        id: String(basicStatus.id ?? basicStatus.value ?? basicStatus.key ?? index),
        statuses: ["Active", "Available", "Assigned"],
        __original: basicStatus
      }));

      console.log("Transformed basic status:", transformedBasicStatus);
      console.log("Setting basicStatusAPIData and basicStatusWorkTypes to:", transformedBasicStatus);
      setBasicStatusAPIData([...transformedBasicStatus, lookupAddSentinel, lookupEditSentinel]);
      setBasicStatusWorkTypes(transformedBasicStatus);

      // If we already have selectedBasicStatus as an id (from employee data), set the selectedBasicStatus object
      if (employeeData && employeeData.employee_status) {
        const found = transformedBasicStatus.find(bs => String(bs.id) === String(employeeData.employee_status) || String(bs.__original?.id) === String(employeeData.employee_status) || String(bs.__original?.value) === String(employeeData.employee_status));
        if (found) setSelectedBasicStatus(found);
      }
    } catch (error) {
      console.error("Error loading basic status:", error);
    }
  };

  const loadEmployeeTypeData = async () => {
    try {
      console.log("Loading employee type from database...");
      const response = await getLookupsByName("employee_employeeType");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No employee type items found in lookup response:', response);
        return;
      }

      const transformedEmployeeType = rawItems.map((empType, index) => ({
        name: empType.value || empType.name || empType.label || String(empType.id) || `Employee Type ${index}`,
        color: "#000000",
        id: String(empType.id ?? empType.value ?? empType.key ?? index),
        statuses: ["Active", "Available", "Assigned"],
        __original: empType
      }));

      console.log("Transformed employee type:", transformedEmployeeType);
      setEmployeeTypeAPIData([...transformedEmployeeType]);

      // If we already have selectedEmployeeType as an id (from employee data), set the selectedEmployeeType object
      if (employeeData && employeeData.employeeType) {
        const found = transformedEmployeeType.find(et => String(et.id) === String(employeeData.employeeType) || String(et.__original?.id) === String(employeeData.employeeType) || String(et.__original?.value) === String(employeeData.employeeType));
        if (found) setSelectedEmployeeType(found);
      }
    } catch (error) {
      console.error("Error loading employee type:", error);
    }
  };

  const loadSubDepartmentData = async () => {
    try {
      console.log("Loading sub departments from database...");
      const response = await getLookupsByName("employee_subDepartment");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No sub department items found in lookup response:', response);
        return;
      }

      const transformedSubDepartments = rawItems.map((subDept, index) => ({
        name: subDept.value || subDept.name || subDept.label || String(subDept.id) || `Sub Department ${index}`,
        color: "#000000",
        id: String(subDept.id ?? subDept.value ?? subDept.key ?? index),
        statuses: ["Active", "Available", "Assigned"],
        __original: subDept
      }));

      console.log("Transformed sub departments:", transformedSubDepartments);
      setSubDepartmentAPIData([...transformedSubDepartments]);

      // If we already have selectedSubDepartment as an id (from employee data), set the selectedSubDepartment object
      if (employeeData && employeeData.subDepartment) {
        const found = transformedSubDepartments.find(sd => String(sd.id) === String(employeeData.subDepartment) || String(sd.__original?.id) === String(employeeData.subDepartment) || String(sd.__original?.value) === String(employeeData.subDepartment));
        if (found) setSelectedSubDepartment(found);
      }
    } catch (error) {
      console.error("Error loading sub departments:", error);
    }
  };

  const loadEmployeesData = async () => {
    try {
      console.log("Loading employees from database...");
      const response = await getEmployees();
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No employee items found in response:', response);
        return;
      }

      const transformedEmployees = rawItems.map((employee, index) => {
        // Resolve designation name from designation work types
        let designationName = '';
        if (employee.designation && designationWorkTypes && designationWorkTypes.length > 0) {
          const designationObj = designationWorkTypes.find(d => 
            String(d.id) === String(employee.designation) || 
            String(d.__original?.id) === String(employee.designation)
          );
          designationName = designationObj ? designationObj.name : '';
        }

        return {
          name: `${employee.first_name || ''} ${employee.last_name || ''}`.trim() + (designationName ? ` - ${designationName}` : ''),
          color: "#000000",
          id: String(employee.id ?? index),
          statuses: ["Active", "Available", "Assigned"],
          __original: employee
        };
      });

      console.log("Transformed employees:", transformedEmployees);
      setEmployeesAPIData(transformedEmployees);

      // If we already have selectedReportingManager as an id (from employee data), set the selectedReportingManager object
      if (employeeData && employeeData.reportingManager) {
        const found = transformedEmployees.find(emp => String(emp.id) === String(employeeData.reportingManager) || String(emp.__original?.id) === String(employeeData.reportingManager));
        if (found) setSelectedReportingManager(found);
      }
    } catch (error) {
      console.error("Error loading employees:", error);
    }
  };

  const loadCategoriesData = async () => {
    try {
      console.log("Loading categories from database...");
      const response = await getLookupsByName("employee_categories");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No category items found in lookup response:', response);
        return;
      }

      const transformedCategories = rawItems.map((category, index) => ({
        key: String(category.id ?? category.value ?? category.key ?? index),
        label: category.value || category.name || category.label || String(category.id) || `Category ${index}`,
        __original: category
      }));

      console.log("Transformed categories:", transformedCategories);
      setCategoriesAPIData(transformedCategories);

      // If we already have selectedCategoryKey as an id (from employee data), set it
      if (employeeData && employeeData.categories) {
        const categoryId = Array.isArray(employeeData.categories) ? employeeData.categories[0] : employeeData.categories;
        const found = transformedCategories.find(cat => String(cat.key) === String(categoryId) || String(cat.__original?.id) === String(categoryId));
        if (found) setSelectedCategoryKey(found.key);
      }
    } catch (error) {
      console.error("Error loading categories:", error);
    }
  };

  const loadGroupsData = async () => {
    try {
      console.log("Loading groups from database...");
      const response = await getLookupsByName("employee_group");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No group items found in lookup response:', response);
        return;
      }

      const transformedGroups = rawItems.map((group, index) => ({
        key: String(group.id ?? group.value ?? group.key ?? index),
        label: group.value || group.name || group.label || String(group.id) || `Group ${index}`,
        __original: group
      }));

      console.log("Transformed groups:", transformedGroups);
      setGroupsAPIData(transformedGroups);

      // If we already have selectedGroupKey as an id (from employee data), set it
      if (employeeData && employeeData.groups) {
        const groupId = Array.isArray(employeeData.groups) ? employeeData.groups[0] : employeeData.groups;
        const found = transformedGroups.find(grp => String(grp.key) === String(groupId) || String(grp.__original?.id) === String(groupId));
        if (found) setSelectedGroupKey(found.key);
      }
    } catch (error) {
      console.error("Error loading groups:", error);
    }
  };

  const loadPrimarySkillsData = async () => {
    try {
      console.log("Loading primary skills from database...");
      const response = await getLookupsByName("employee_primarySkills");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No primary skill items found in lookup response:', response);
        return;
      }

      const transformedPrimarySkills = rawItems.map((skill, index) => ({
        value: String(skill.id ?? skill.value ?? skill.key ?? index),
        label: skill.value || skill.name || skill.label || String(skill.id) || `Skill ${index}`,
        __original: skill
      }));

      console.log("Transformed primary skills:", transformedPrimarySkills);
      setPrimarySkillsAPIData(transformedPrimarySkills);
      
      console.log("Primary skills API data set:", transformedPrimarySkills);
      console.log("Current selectedPrimarySkills state:", selectedPrimarySkills);

      // Update skillsOptions with API data (for backward compatibility)
      setSkillsOptions(transformedPrimarySkills);

      // If we already have selectedPrimarySkills from employee data, set them
      if (employeeData && employeeData.primary_skills) {
        const skills = Array.isArray(employeeData.primary_skills) ? employeeData.primary_skills : [employeeData.primary_skills];
        const matchedSkills = skills.map(skillId => 
          transformedPrimarySkills.find(skill => 
            String(skill.value) === String(skillId) || 
            String(skill.__original?.id) === String(skillId)
          )?.value
        ).filter(Boolean);
        // setSelectedPrimarySkills(matchedSkills);
      }
    } catch (error) {
      console.error("Error loading primary skills:", error);
    }
  };

  const loadSecondarySkillsData = async () => {
    try {
      console.log("Loading secondary skills from database...");
      const response = await getLookupsByName("employee_secondarySkills");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No secondary skill items found in lookup response:', response);
        return;
      }

      const transformedSecondarySkills = rawItems.map((skill, index) => ({
        name: skill.value || skill.name || skill.label || String(skill.id) || `Skill ${index}`,
        value: String(skill.id ?? skill.value ?? skill.key ?? index),
        __original: skill
      }));

      console.log("Transformed secondary skills:", transformedSecondarySkills);
      setSecondarySkillsAPIData(transformedSecondarySkills);
      
      console.log("Secondary skills API data set:", transformedSecondarySkills);
      console.log("Current secondarySkills state:", secondarySkills);

      // If we already have secondarySkills from employee data, set them
      if (employeeData && employeeData.secondary_skills) {
        const found = transformedSecondarySkills.find(skill => 
          String(skill.value) === String(employeeData.secondary_skills) || 
          String(skill.__original?.id) === String(employeeData.secondary_skills) ||
          skill.name === employeeData.secondary_skills
        );
        if (found) setSecondarySkills(found);
      }
    } catch (error) {
      console.error("Error loading secondary skills:", error);
    }
  };

  const loadOtherSkillsData = async () => {
    try {
      console.log("Loading other skills from database...");
      const response = await getLookupsByName("employee_otherSkills");
      // Normalize possible response shapes into an array of items
      let rawItems = [];
      if (response) {
        if (Array.isArray(response)) rawItems = response;
        else if (Array.isArray(response.results)) rawItems = response.results;
        else if (Array.isArray(response.results?.results)) rawItems = response.results.results;
        else if (Array.isArray(response.data)) rawItems = response.data;
        else if (Array.isArray(response.items)) rawItems = response.items;
      }

      if (rawItems.length === 0) {
        console.warn('No other skill items found in lookup response:', response);
        return;
      }

      const transformedOtherSkills = rawItems.map((skill, index) => ({
        name: skill.value || skill.name || skill.label || String(skill.id) || `Skill ${index}`,
        value: String(skill.id ?? skill.value ?? skill.key ?? index),
        __original: skill
      }));

      console.log("Transformed other skills:", transformedOtherSkills);
      setOtherSkillsAPIData(transformedOtherSkills);
      
      console.log("Other skills API data set:", transformedOtherSkills);
      console.log("Current otherSkills state:", otherSkills);

      // If we already have otherSkills from employee data, set them
      if (employeeData && employeeData.other_skills) {
        const found = transformedOtherSkills.find(skill => 
          String(skill.value) === String(employeeData.other_skills) || 
          String(skill.__original?.id) === String(employeeData.other_skills) ||
          skill.name === employeeData.other_skills
        );
        if (found) setOtherSkills(found);
      }
    } catch (error) {
      console.error("Error loading other skills:", error);
    }
  };

  // Load all required data
  useEffect(() => {
    loadCompanyData();
    loadDesignationData();
    loadDepartmentData();
    loadWorkLocationData();
    loadShiftTimingsData();
    loadEmployeeStatusData();
    loadBasicStatusData(); // Load basic status for Basic Information section
    loadEmployeeTypeData();
    loadSubDepartmentData(); // Load sub departments for sub department dropdown
    loadCategoriesData();
    loadGroupsData();
    loadPrimarySkillsData();
    loadSecondarySkillsData();
    loadOtherSkillsData();
    // Note: loadEmployeesData() is called separately after designations are loaded
    
    if (isEditMode) {
      loadEmployeeData();
    }
  }, [employeeId, isEditMode]);

  // When moduleWorkTypes load, ensure selectedModule is the full object if we only had an id
  useEffect(() => {
    if (moduleWorkTypes && selectedModule) {
      const sel = moduleWorkTypes.find(m => String(m.id) === String(selectedModule.id) || String(m.id) === String(selectedModule.__original?.id) || String(m.__original?.id) === String(selectedModule.id));
      if (sel) setSelectedModule(sel);
    }
  }, [moduleWorkTypes, selectedModule]);

  // When designationWorkTypes load, ensure selectedDesignation is the full object if we only had an id
  useEffect(() => {
    if (designationWorkTypes && selectedDesignation) {
      const sel = designationWorkTypes.find(d =>
        String(d.id) === String(selectedDesignation.id) ||
        String(d.__original?.id) === String(selectedDesignation.id) ||
        String(d.__original?.value) === String(selectedDesignation.id) ||
        String(d.id) === String(selectedDesignation.__original?.id) ||
        String(d.name) === String(selectedDesignation.name)
      );
      if (sel) setSelectedDesignation(sel);
    }
  }, [designationWorkTypes, selectedDesignation]);

  // Load employees after designations are loaded (so we can resolve designation names)
  useEffect(() => {
    if (designationWorkTypes && designationWorkTypes.length > 0) {
      loadEmployeesData();
    }
  }, [designationWorkTypes]);

  // When departmentWorkTypes load, ensure selectedDepartment is the full object if we only had an id
  useEffect(() => {
    if (departmentWorkTypes && selectedDepartment) {
      const sel = departmentWorkTypes.find(d =>
        String(d.id) === String(selectedDepartment.id) ||
        String(d.__original?.id) === String(selectedDepartment.id) ||
        String(d.__original?.value) === String(selectedDepartment.id) ||
        String(d.id) === String(selectedDepartment.__original?.id) ||
        String(d.name) === String(selectedDepartment.name)
      );
      if (sel) setSelectedDepartment(sel);
    }
  }, [departmentWorkTypes, selectedDepartment]);

  // When workLocationAPIData load, ensure selectedWorkLocation is the full object if we only had an id
  useEffect(() => {
    if (workLocationAPIData && workLocationAPIData.length > 0) {
      // If we have a selectedWorkLocation that's incomplete, try to find the full object
      if (selectedWorkLocation) {
        const sel = workLocationAPIData.find(wl =>
          String(wl.id) === String(selectedWorkLocation.id) ||
          String(wl.__original?.id) === String(selectedWorkLocation.id) ||
          String(wl.__original?.value) === String(selectedWorkLocation.id) ||
          String(wl.id) === String(selectedWorkLocation.__original?.id) ||
          String(wl.name) === String(selectedWorkLocation.name)
        );
        if (sel && sel !== selectedWorkLocation) setSelectedWorkLocation(sel);
      }
      
      // Also check if we have employeeData with work_location but no selectedWorkLocation set
      if (!selectedWorkLocation && employeeData && employeeData.work_location !== undefined) {
        if (employeeData.work_location) {
          const found = workLocationAPIData.find(wl => 
            String(wl.id) === String(employeeData.work_location) || 
            String(wl.__original?.id) === String(employeeData.work_location) || 
            String(wl.__original?.value) === String(employeeData.work_location) ||
            String(wl.name) === String(employeeData.work_location)
          );
          if (found) setSelectedWorkLocation(found);
        } else {
          // Clear selection if work_location is null
          setSelectedWorkLocation(null);
        }
      }
    }
  }, [workLocationAPIData, selectedWorkLocation, employeeData]);

  // When shiftTimingsAPIData load, ensure selectedShiftTimings is the full object if we only had an id
  useEffect(() => {
    if (shiftTimingsAPIData && selectedShiftTimings) {
      const sel = shiftTimingsAPIData.find(st =>
        String(st.id) === String(selectedShiftTimings.id) ||
        String(st.__original?.id) === String(selectedShiftTimings.id) ||
        String(st.__original?.value) === String(selectedShiftTimings.id) ||
        String(st.id) === String(selectedShiftTimings.__original?.id) ||
        String(st.name) === String(selectedShiftTimings.name)
      );
      if (sel) setSelectedShiftTimings(sel);
    }
  }, [shiftTimingsAPIData, selectedShiftTimings]);

  // When employeeStatusAPIData load, ensure selectedEmpStatus is the full object if we only had an id
  useEffect(() => {
    if (employeeStatusAPIData && selectedEmpStatus) {
      const sel = employeeStatusAPIData.find(es =>
        String(es.id) === String(selectedEmpStatus.id) ||
        String(es.__original?.id) === String(selectedEmpStatus.id) ||
        String(es.__original?.value) === String(selectedEmpStatus.id) ||
        String(es.id) === String(selectedEmpStatus.__original?.id) ||
        String(es.name) === String(selectedEmpStatus.name)
      );
      if (sel) setSelectedEmpStatus(sel);
    }
  }, [employeeStatusAPIData, selectedEmpStatus]);

  // When basicStatusAPIData load, ensure selectedBasicStatus is the full object if we only had an id
  useEffect(() => {
    if (basicStatusAPIData && selectedBasicStatus) {
      const sel = basicStatusAPIData.find(bs =>
        String(bs.id) === String(selectedBasicStatus.id) ||
        String(bs.__original?.id) === String(selectedBasicStatus.id) ||
        String(bs.__original?.value) === String(selectedBasicStatus.id) ||
        String(bs.id) === String(selectedBasicStatus.__original?.id) ||
        String(bs.name) === String(selectedBasicStatus.name)
      );
      if (sel) setSelectedBasicStatus(sel);
    }
  }, [basicStatusAPIData, selectedBasicStatus]);

  // When basicStatusAPIData load, ensure selectedBasicStatus is properly set from employee data
  useEffect(() => {
    if (basicStatusAPIData && basicStatusAPIData.length > 0 && employeeData && employeeData.employee_status !== undefined) {
      if (employeeData.employee_status) {
        const found = basicStatusAPIData.find(bs => 
          String(bs.id) === String(employeeData.employee_status) || 
          String(bs.__original?.id) === String(employeeData.employee_status) || 
          String(bs.__original?.value) === String(employeeData.employee_status)
        );
        if (found) setSelectedBasicStatus(found);
      } else {
        // Clear selection if employee_status is null
        setSelectedBasicStatus(null);
      }
    }
  }, [basicStatusAPIData, employeeData]);

  // When departmentWorkTypes load, ensure selectedDepartment is properly set from employee data
  useEffect(() => {
    if (departmentWorkTypes && departmentWorkTypes.length > 0 && employeeData && employeeData.department !== undefined) {
      if (employeeData.department) {
        const found = departmentWorkTypes.find(dept => 
          String(dept.id) === String(employeeData.department) || 
          String(dept.__original?.id) === String(employeeData.department) || 
          String(dept.__original?.value) === String(employeeData.department)
        );
        if (found) setSelectedDepartment(found);
      } else {
        // Clear selection if department is null
        setSelectedDepartment(null);
      }
    }
  }, [departmentWorkTypes, employeeData]);

  // When subDepartmentAPIData load, ensure selectedSubDepartment is properly set from employee data
  useEffect(() => {
    if (subDepartmentAPIData && subDepartmentAPIData.length > 0 && employeeData && employeeData.subDepartment !== undefined) {
      if (employeeData.subDepartment) {
        const found = subDepartmentAPIData.find(subDept => 
          String(subDept.id) === String(employeeData.subDepartment) || 
          String(subDept.__original?.id) === String(employeeData.subDepartment) || 
          String(subDept.__original?.value) === String(employeeData.subDepartment)
        );
        if (found) setSelectedSubDepartment(found);
      } else {
        // Clear selection if sub_department is null
        setSelectedSubDepartment(null);
      }
    }
  }, [subDepartmentAPIData, employeeData]);

  // When employeeTypeAPIData load, ensure selectedEmployeeType is properly set from employee data
  useEffect(() => {
    if (employeeTypeAPIData && employeeTypeAPIData.length > 0 && employeeData && employeeData.employee_type !== undefined) {
      if (employeeData.employee_type) {
        const found = employeeTypeAPIData.find(empType => 
          String(empType.id) === String(employeeData.employee_type) || 
          String(empType.__original?.id) === String(employeeData.employee_type) || 
          String(empType.__original?.value) === String(employeeData.employee_type)
        );
        if (found) setSelectedEmployeeType(found);
      } else {
        // Clear selection if employee_type is null
        setSelectedEmployeeType(null);
      }
    }
  }, [employeeTypeAPIData, employeeData]);

  // When shiftTimingsAPIData load, ensure selectedShiftTimings is properly set from employee data
  useEffect(() => {
    if (shiftTimingsAPIData && shiftTimingsAPIData.length > 0 && employeeData && employeeData.shift_timings !== undefined) {
      if (employeeData.shift_timings) {
        const found = shiftTimingsAPIData.find(shift => 
          String(shift.id) === String(employeeData.shift_timings) || 
          String(shift.__original?.id) === String(employeeData.shift_timings) || 
          String(shift.__original?.value) === String(employeeData.shift_timings)
        );
        if (found) setSelectedShiftTimings(found);
      } else {
        // Clear selection if shift_timings is null
        setSelectedShiftTimings(null);
      }
    }
  }, [shiftTimingsAPIData, employeeData]);

  // When employeesAPIData load, ensure selectedReportingManager is properly set from employee data
  useEffect(() => {
    if (employeesAPIData && employeesAPIData.length > 0 && employeeData && employeeData.reporting_manager !== undefined) {
      if (employeeData.reporting_manager) {
        const found = employeesAPIData.find(emp => 
          String(emp.id) === String(employeeData.reporting_manager) || 
          String(emp.__original?.id) === String(employeeData.reporting_manager)
        );
        if (found) setSelectedReportingManager(found);
      } else {
        // Clear selection if reporting_manager is null
        setSelectedReportingManager(null);
      }
    }
  }, [employeesAPIData, employeeData]);

  // When employeeTypeAPIData load, ensure selectedEmployeeType is the full object if we only had an id
  useEffect(() => {
    if (employeeTypeAPIData && selectedEmployeeType) {
      const sel = employeeTypeAPIData.find(et =>
        String(et.id) === String(selectedEmployeeType.id) ||
        String(et.__original?.id) === String(selectedEmployeeType.id) ||
        String(et.__original?.value) === String(selectedEmployeeType.id) ||
        String(et.id) === String(selectedEmployeeType.__original?.id) ||
        String(et.name) === String(selectedEmployeeType.name)
      );
      if (sel) setSelectedEmployeeType(sel);
    }
  }, [employeeTypeAPIData, selectedEmployeeType]);

  // When subDepartmentAPIData load, ensure selectedSubDepartment is the full object if we only had an id
  useEffect(() => {
    if (subDepartmentAPIData && selectedSubDepartment) {
      const sel = subDepartmentAPIData.find(sd =>
        String(sd.id) === String(selectedSubDepartment.id) ||
        String(sd.__original?.id) === String(selectedSubDepartment.id) ||
        String(sd.__original?.value) === String(selectedSubDepartment.id) ||
        String(sd.id) === String(selectedSubDepartment.__original?.id) ||
        String(sd.name) === String(selectedSubDepartment.name)
      );
      if (sel) setSelectedSubDepartment(sel);
    }
  }, [subDepartmentAPIData, selectedSubDepartment]);

  // When employeesAPIData load, ensure selectedReportingManager is the full object if we only had an id
  useEffect(() => {
    if (employeesAPIData && selectedReportingManager) {
      const sel = employeesAPIData.find(emp =>
        String(emp.id) === String(selectedReportingManager.id) ||
        String(emp.__original?.id) === String(selectedReportingManager.id) ||
        String(emp.id) === String(selectedReportingManager.__original?.id) ||
        String(emp.name) === String(selectedReportingManager.name)
      );
      if (sel) setSelectedReportingManager(sel);
    }
  }, [employeesAPIData, selectedReportingManager]);

  // When categoriesAPIData load, ensure selectedCategoryKey is properly set
  useEffect(() => {
    if (categoriesAPIData && categoriesAPIData.length > 0 && employeeData && employeeData.categories) {
      const categoryId = Array.isArray(employeeData.categories) ? employeeData.categories[0] : employeeData.categories;
      const found = categoriesAPIData.find(cat => String(cat.key) === String(categoryId) || String(cat.__original?.id) === String(categoryId));
      if (found) setSelectedCategoryKey(found.key);
    }
  }, [categoriesAPIData, employeeData]);

  // When groupsAPIData load, ensure selectedGroupKey is properly set
  useEffect(() => {
    if (groupsAPIData && groupsAPIData.length > 0 && employeeData && employeeData.groups) {
      const groupId = Array.isArray(employeeData.groups) ? employeeData.groups[0] : employeeData.groups;
      const found = groupsAPIData.find(grp => String(grp.key) === String(groupId) || String(grp.__original?.id) === String(groupId));
      if (found) setSelectedGroupKey(found.key);
    }
  }, [groupsAPIData, employeeData]);

  // When primarySkillsAPIData load, ensure selectedPrimarySkills is properly set
  useEffect(() => {
    if (primarySkillsAPIData && primarySkillsAPIData.length > 0 && employeeData && employeeData.primary_skills !== undefined) {
      if (employeeData.primary_skills) {
        // If primary_skills is a string, split it; if it's an array, use as is
        const skillsArray = typeof employeeData.primary_skills === 'string' 
          ? employeeData.primary_skills.split(',').map(skill => skill.trim()).filter(skill => skill)
          : (Array.isArray(employeeData.primary_skills) ? employeeData.primary_skills : []);
        
        // Find matching skills in the API data and set the IDs
        const matchedSkills = [];
        skillsArray.forEach(skillId => {
          const found = primarySkillsAPIData.find(skill => 
            String(skill.value) === String(skillId) || 
            String(skill.__original?.id) === String(skillId) ||
            String(skill.id) === String(skillId)
          );
          if (found) {
            matchedSkills.push(found.value || found.id);
          }
        });
        // setSelectedPrimarySkills(matchedSkills);
      } else {
        // Clear selection if primary_skills is null
        // setSelectedPrimarySkills([]);
      }
    }
  }, [primarySkillsAPIData, employeeData]);

  // When secondarySkillsAPIData load, ensure secondarySkills is properly set
  useEffect(() => {
    if (secondarySkillsAPIData && secondarySkillsAPIData.length > 0 && employeeData && employeeData.secondary_skills !== undefined) {
      if (employeeData.secondary_skills) {
        // If secondary_skills is a string, split it; if it's an array, use as is
        const skillsArray = typeof employeeData.secondary_skills === 'string' 
          ? employeeData.secondary_skills.split(',').map(skill => skill.trim()).filter(skill => skill)
          : (Array.isArray(employeeData.secondary_skills) ? employeeData.secondary_skills : []);
        
        // Find matching skills in the API data and set the IDs
        const matchedSkills = [];
        skillsArray.forEach(skillName => {
          const found = secondarySkillsAPIData.find(skill => 
            skill.name === skillName || String(skill.value) === String(skillName) || String(skill.id) === String(skillName)
          );
          if (found) {
            matchedSkills.push(found.value || found.id);
          }
        });
        setSecondarySkills(matchedSkills);
      } else {
        // Clear selection if secondary_skills is null
        setSecondarySkills([]);
      }
    }
  }, [secondarySkillsAPIData, employeeData]);

  // When otherSkillsAPIData load, ensure otherSkills is properly set
  useEffect(() => {
    if (otherSkillsAPIData && otherSkillsAPIData.length > 0 && employeeData && employeeData.other_skills !== undefined) {
      if (employeeData.other_skills) {
        // If other_skills is a string, split it; if it's an array, use as is
        const skillsArray = typeof employeeData.other_skills === 'string' 
          ? employeeData.other_skills.split(',').map(skill => skill.trim()).filter(skill => skill)
          : (Array.isArray(employeeData.other_skills) ? employeeData.other_skills : []);
        
        // Find matching skills in the API data and set the IDs
        const matchedSkills = [];
        skillsArray.forEach(skillName => {
          const found = otherSkillsAPIData.find(skill => 
            skill.name === skillName || String(skill.value) === String(skillName) || String(skill.id) === String(skillName)
          );
          if (found) {
            matchedSkills.push(found.value || found.id);
          }
        });
        setOtherSkills(matchedSkills);
      } else {
        // Clear selection if other_skills is null
        setOtherSkills([]);
      }
    }
  }, [otherSkillsAPIData, employeeData]);


  // Remove duplicate navigate declaration
  // const navigate = useNavigate();

  const handleSaveClick = () => {
    // Perform any additional logic if needed
    // console.log('Save button clicked');

    // Navigate to another page
    setMerge(true);

  };
  const [pathSegment, setPathSegment] = useState(null);
  useEffect(() => {
    const url = new URL(window.location.href); // Get the current URL
    const pathParts = url.pathname.split('/'); // Split the pathname into parts
    const lastSegment = pathParts[pathParts.length - 1]; // Get the last part of the path

    setPathSegment(lastSegment); // Set the last segment to state

  }, []);

  const [merge, setMerge] = useState(false);
  const footerContent = (
    <div className="d-flex justify-content-center">
      <button type="button" onClick={() => {
        navigate('/allactive-employees');

      }} class="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary me-2">Yes</button>

      <button type="button" onClick={() => {
        navigate('/allactive-employees');

      }} class="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary me-2">No</button>
    </div>
  );

  const { register, handleSubmit, reset, trigger, clearErrors, formState: { errors }, setValue, getValues } = useForm();


  const getcategoriesitem = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_CONDIDATES}/api/v1/candidates/${pathSegment}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        let results = response.data;
        setValue("firstname", results.first_name);
        setValue("lastname", results.last_name);
        setValue("jobtitle", results.job_title);
        setValue("personal_email", results.email);
        setValue("Email2", results.email_2);
        setValue("phone", results.mobile_phone);

        setValue("Company", results.country);

        console.log(results)

      }
    } catch (error) {

    }
  };

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      
      console.log("Form data received:", data); // Debug log to see all form data

      // Extract company ID from selected company
      let companyId = null;
      
      if (selectedModule) {
        companyId = selectedModule.__original?.id || selectedModule.id;
        
        // Convert to number if it's a stringified number
        if (typeof companyId === 'string' && !isNaN(companyId) && !companyId.startsWith('custom-')) {
          companyId = parseInt(companyId, 10);
        }
      }
      
      // Validate company selection
      if (!companyId || companyId === 'divider' || String(companyId).startsWith('create-new-') || String(companyId).startsWith('edit-selected-') || String(companyId).startsWith('custom-')) {
        toast.current?.show({ 
          severity: 'error', 
          summary: 'Error', 
          detail: 'Please select a valid company' 
        });
        return;
      }

      console.log("Form submission data:", {
        data,
        selectedWorkLocation,
        primarySkills,
        secondarySkills,
        otherSkills,
        selectedPrimarySkills, // Add this for debugging
        formData
      });

      console.log("Work location values:", {
        selectedWorkLocation: selectedWorkLocation,
        selectedWorkLocationName: selectedWorkLocation?.name,
        formDataWorkLocation: formData.work_location,
        finalWorkLocation: selectedWorkLocation ? selectedWorkLocation.name : (formData.work_location || "")
      });
      
      console.log("Date of joining values:", {
        dataAvailability: data.Availability,
        dateOfJoiningState: dateOfJoining,
        formDataDateOfJoining: formData.date_of_joining,
        finalDateOfJoining: dateOfJoining ? moment(dateOfJoining).format("YYYY-MM-DD") : 
                            (formData.date_of_joining ? moment(formData.date_of_joining).format("YYYY-MM-DD") : null)
      });

      console.log("Reporting manager values:", {
        selectedReportingManager: selectedReportingManager,
        selectedReportingManagerId: selectedReportingManager?.id,
        selectedReportingManagerOriginalId: selectedReportingManager?.__original?.id,
        finalReportingManagerId: selectedReportingManager ? (selectedReportingManager.id || selectedReportingManager.__original?.id) : null
      });

      console.log("Debugging all lookup-based fields before payload creation:");
      console.log("selectedBasicStatus:", selectedBasicStatus);
      console.log("selectedSubDepartment:", selectedSubDepartment);
      console.log("selectedEmployeeType:", selectedEmployeeType);
      console.log("selectedShiftTimings:", selectedShiftTimings);
      console.log("selectedReportingManager:", selectedReportingManager);
      console.log("selectedDepartment:", selectedDepartment);
      console.log("selectedDesignation:", selectedDesignation);
      console.log("selectedWorkLocation:", selectedWorkLocation);
      console.log("employee_status will be:", selectedBasicStatus ? (selectedBasicStatus.id || selectedBasicStatus.__original?.id || selectedBasicStatus.code || selectedBasicStatus.value) : null);
      console.log("sub_department will be:", selectedSubDepartment ? (selectedSubDepartment.id || selectedSubDepartment.__original?.id || selectedSubDepartment.code || selectedSubDepartment.value) : null);
      console.log("employee_type will be:", selectedEmployeeType ? (selectedEmployeeType.id || selectedEmployeeType.__original?.id || selectedEmployeeType.code || selectedEmployeeType.value) : null);
      console.log("shift_timings will be:", selectedShiftTimings ? (selectedShiftTimings.id || selectedShiftTimings.__original?.id || selectedShiftTimings.code || selectedShiftTimings.value) : null);
      console.log("reporting_manager will be:", selectedReportingManager ? (selectedReportingManager.id || selectedReportingManager.__original?.id || selectedReportingManager.code || selectedReportingManager.value) : null);
      console.log("department will be:", selectedDepartment ? (selectedDepartment.id || selectedDepartment.__original?.id || selectedDepartment.code || selectedDepartment.value) : null);
      console.log("designation will be:", selectedDesignation ? (selectedDesignation.id || selectedDesignation.__original?.id || selectedDesignation.code || selectedDesignation.value) : null);
      console.log("work_location will be:", selectedWorkLocation ? (selectedWorkLocation.name || selectedWorkLocation.value || selectedWorkLocation.label) : null);

      // Prepare employee data payload
      const employeePayload = {
        first_name: data.firstname || formData.first_name || "",
        last_name: data.lastname || formData.last_name || "",
        primary_email: data.personal_email || formData.primary_email || "",
        secondary_email: data.Email2 || formData.secondary_email || "",
        personal_phone: data.phone || formData.personal_phone || "",
        designation: selectedDesignation ? 
                    (selectedDesignation.id || selectedDesignation.__original?.id || selectedDesignation.code || selectedDesignation.value || data.Designation || formData.designation) : 
                    (data.Designation || formData.designation || ""),
        company: companyId,
        date_of_joining: dateOfJoining ? moment(dateOfJoining).format("YYYY-MM-DD") : 
                        (formData.date_of_joining ? moment(formData.date_of_joining).format("YYYY-MM-DD") : null),
        
        // Work location field - send the name (string) not the ID
        work_location: selectedWorkLocation ? (selectedWorkLocation.name || selectedWorkLocation.value || selectedWorkLocation.label) : 
                      (formData.work_location || ""),
        
        // Reporting manager field - send the ID
        reporting_manager: selectedReportingManager ? 
                          (selectedReportingManager.id || selectedReportingManager.__original?.id || selectedReportingManager.code || selectedReportingManager.value) : 
                          (isEditMode && employeeData?.reportingManager ? employeeData.reportingManager : null),
        
        // Employee status field - send the ID (from Basic Information section using employee_status lookup)
        employee_status: selectedBasicStatus ? 
                        (selectedBasicStatus.id || selectedBasicStatus.__original?.id || selectedBasicStatus.code || selectedBasicStatus.value) : 
                        (isEditMode && employeeData?.employee_status ? employeeData.employee_status : null),
        employee_employeeStatus: selectedEmpStatus ? 
                                (selectedEmpStatus.id || selectedEmpStatus.__original?.id || selectedEmpStatus.code || selectedEmpStatus.value) : 
                                (isEditMode && employeeData?.employee_employeeStatus ? employeeData.employee_employeeStatus : null),
        department: selectedDepartment ? 
                   (selectedDepartment.id || selectedDepartment.__original?.id || selectedDepartment.code || selectedDepartment.value) : 
                   (isEditMode && employeeData?.department ? employeeData.department : null),
        
        // Sub Department field - send the ID  
        sub_department: selectedSubDepartment ? 
                       (selectedSubDepartment.id || selectedSubDepartment.__original?.id || selectedSubDepartment.code || selectedSubDepartment.value) : 
                       (isEditMode && employeeData?.subDepartment ? employeeData.subDepartment : null),
        
        // Employee Type field - send the ID
        employee_type: selectedEmployeeType ? 
                      (selectedEmployeeType.id || selectedEmployeeType.__original?.id || selectedEmployeeType.code || selectedEmployeeType.value) : 
                      (isEditMode && employeeData?.employee_type ? employeeData.employee_type : null),
        
        // Shift Timings field - send the ID
        shift_timings: selectedShiftTimings ? 
                      (selectedShiftTimings.id || selectedShiftTimings.__original?.id || selectedShiftTimings.code || selectedShiftTimings.value) : 
                      (isEditMode && employeeData?.shift_timings ? employeeData.shift_timings : null),
        
        // Required fields
        employee_id: isEditMode ? (employeeData?.employee_id || employeeId) : `EMP${Date.now()}`, // Use existing employee_id in edit mode
        office_phone: data.office_phone || formData.office_phone || data.phone || formData.personal_phone || "", // Use office_phone first, then personal_phone as fallback
        
        // Fix primary_skills format - send as comma-separated IDs
        // primary_skills: Array.isArray(selectedPrimarySkills) && selectedPrimarySkills.length > 0
        //   ? selectedPrimarySkills.join(',')
        //   : (Array.isArray(formData.primary_skills) 
        //       ? formData.primary_skills.map(skill => typeof skill === 'object' ? skill.id || skill.value : skill).join(',')
        //       : (formData.primary_skills || "")),
        primary_skills: selectedPrimarySkills.join(','),
        // Add other optional fields
        ...(data.JobTitle && { job_title: data.JobTitle }),
        ...(currentSalary && { current_salary: parseInt(currentSalary) || 0 }),
        ...(expectedSalary && { expected_salary: parseInt(expectedSalary) || 0 }),
        ...(dob && { date_of_birth: moment(dob).format("YYYY-MM-DD") }),
        ...(totalExperience && { total_experience: parseInt(totalExperience) || 0 }),
        
        // Address field - ensure it's a string
        address: (address && Array.isArray(address)) ? address.join(', ') : 
                 (address && typeof address === 'string') ? address : 
                 (address && typeof address === 'object') ? JSON.stringify(address) : 
                 (data.address && typeof data.address === 'string') ? data.address :
                 (formData.address && typeof formData.address === 'string') ? formData.address : "",
        
        // Additional fields that might be expected by the backend
        secondary_skills: Array.isArray(secondarySkills) ? secondarySkills.join(',') : "",
        other_skills: Array.isArray(otherSkills) ? otherSkills.join(',') : "",
        
        // Add resume document ID if available (backend expects 'resume' field)
        ...(resumeDocumentId && { resume: resumeDocumentId }),
        is_private: privateDrop,
       ...(privateDrop && {
          private_users: PrivetDropdown
        })

      };

      console.log("Final employee data being sent to API:", employeePayload);

      // Clean up undefined values and ensure required fields have default values
      Object.keys(employeePayload).forEach(key => {
        if (employeePayload[key] === undefined || employeePayload[key] === null) {
          if (key === 'date_of_joining') {
            employeePayload[key] = null; // Allow null for date
          } else if (typeof employeePayload[key] === 'string' || key.includes('phone') || key.includes('email') || key.includes('name') || key.includes('skills')) {
            employeePayload[key] = ""; // Empty string for text fields
          } else if (typeof employeePayload[key] === 'number') {
            employeePayload[key] = 0; // Zero for numeric fields
          }
        }
      });

      console.log("=== DEBUGGING PROBLEMATIC FIELDS ===");
      console.log("Work Location:", {
        selectedWorkLocation: selectedWorkLocation,
        selectedWorkLocationName: selectedWorkLocation?.name,
        finalWorkLocation: employeePayload.work_location
      });
      console.log("Date of Joining:", {
        dateOfJoiningState: dateOfJoining,
        finalDateOfJoining: employeePayload.date_of_joining
      });
      console.log("Reporting Manager:", {
        selectedReportingManager: selectedReportingManager,
        selectedReportingManagerId: selectedReportingManager?.id,
        finalReportingManager: employeePayload.reporting_manager
      });
      console.log("Employee Status (Basic Info):", {
        selectedBasicStatus: selectedBasicStatus,
        selectedBasicStatusId: selectedBasicStatus?.id,
        finalEmployeeStatus: employeePayload.employee_status
      });
      console.log("Department:", {
        selectedDepartment: selectedDepartment,
        selectedDepartmentId: selectedDepartment?.id,
        finalDepartment: employeePayload.department
      });
      console.log("Sub Department:", {
        selectedSubDepartment: selectedSubDepartment,
        selectedSubDepartmentId: selectedSubDepartment?.id,
        finalSubDepartment: employeePayload.sub_department
      });
      console.log("Employee Type:", {
        selectedEmployeeType: selectedEmployeeType,
        selectedEmployeeTypeId: selectedEmployeeType?.id,
        finalEmployeeType: employeePayload.employee_type
      });
      console.log("Shift Timings:", {
        selectedShiftTimings: selectedShiftTimings,
        selectedShiftTimingsId: selectedShiftTimings?.id,
        finalShiftTimings: employeePayload.shift_timings
      });
      console.log("Skills:", {
        selectedPrimarySkills: selectedPrimarySkills,
        secondarySkills: secondarySkills,
        otherSkills: otherSkills,
        finalPrimarySkills: employeePayload.primary_skills,
        finalSecondarySkills: employeePayload.secondary_skills,
        finalOtherSkills: employeePayload.other_skills
      });
      console.log("=== END DEBUGGING ===");

      console.log("Employee data payload:", employeePayload); // Debug log to see final payload

      // Validate required fields before submitting
      const requiredFields = ['first_name', 'last_name', 'primary_email', 'office_phone'];
      const missingFields = requiredFields.filter(field => !employeePayload[field] || employeePayload[field].trim() === '');
      
      if (missingFields.length > 0) {
        toast.current?.show({ 
          severity: 'error', 
          summary: 'Validation Error', 
          detail: `Please fill in the following required fields: ${missingFields.join(', ')}` 
        });
        return;
      }

      let response;
      if (isEditMode) {
        // Update existing employee
        response = await updateEmployee(employeeId, employeePayload);
        toast.current?.show({ 
          severity: 'success', 
          summary: 'Success', 
          detail: 'Employee updated successfully' 
        });
      } else {
        // Create new employee
        response = await createEmployee(employeePayload);
        
        // Upload resume document for new employee if file is selected (using Companies pattern)
        if (resumeFileRef.current && response && (response.data?.id || response.id)) {
          const newEmployeeId = response.data?.id || response.id;
          
          try {
            console.log('Uploading resume for new employee:', newEmployeeId);
            console.log('Resume file from ref:', resumeFileRef.current);
            
            // Use validated FormData creation like Companies
            const documentFormData = createValidatedResumeFormData(
              resumeFileRef.current, 
              `Resume for employee - ${resumeFileRef.current.name}`
            );
            
            console.log('Created validated FormData for new employee resume, uploading...');
            
            const uploadResult = await createEntityDocument('employees', newEmployeeId, documentFormData);
            
            if (uploadResult && (uploadResult.id || uploadResult.status === 201 || uploadResult.status_code === 201)) {
              const documentId = uploadResult.id;
              console.log('Resume uploaded successfully for new employee, document ID:', documentId);
              
              // Update the newly created employee with the resume document ID
              try {
                console.log('Updating new employee record with resume document ID:', documentId);
                const updatePayload = { resume: documentId };
                const updateResult = await updateEmployee(newEmployeeId, updatePayload);
                console.log('New employee record updated with resume ID:', updateResult);
                
                toast.current?.show({ 
                  severity: 'success', 
                  summary: 'Success', 
                  detail: 'Employee created and resume uploaded and linked successfully!' 
                });
                
                // Navigate to employee view to see the uploaded document
                setTimeout(() => {
                  navigate('/allactive-employees');
                }, 2000);
              } catch (updateError) {
                console.error('Error updating new employee with resume ID:', updateError);
                // Employee and resume were created but linking failed
                toast.current?.show({ 
                  severity: 'warn', 
                  summary: 'Partial Success', 
                  detail: 'Employee created and resume uploaded, but failed to link them. Please reload the employee.' 
                });
              }
            } else {
              throw new Error('Failed to upload resume - invalid response');
            }
          } catch (resumeError) {
            console.error('Error uploading resume for new employee:', resumeError);
            toast.current?.show({ 
              severity: 'warn', 
              summary: 'Partial Success', 
              detail: `Employee created successfully, but resume upload failed: ${resumeError.message || 'Unknown error'}. You can upload it later.` 
            });
          }
        } else if (resumeFile) {
          // Fallback to state file if ref is not available
          console.warn('Resume file ref not available, using state file as fallback');
          const newEmployeeId = response.data?.id || response.id;
          
          if (newEmployeeId) {
            try {
              const documentFormData = createValidatedResumeFormData(
                resumeFile, 
                `Resume for employee - ${resumeFile.name}`
              );
              
              const uploadResult = await createEntityDocument('employees', newEmployeeId, documentFormData);
              
              if (uploadResult && (uploadResult.id || uploadResult.status === 201 || uploadResult.status_code === 201)) {
                const documentId = uploadResult.id;
                console.log('Resume uploaded successfully using fallback method, document ID:', documentId);
                
                // Update the employee record with the resume document ID
                try {
                  const updatePayload = { resume: documentId };
                  await updateEmployee(newEmployeeId, updatePayload);
                  console.log('Employee record updated with resume ID using fallback method');
                  
                  toast.current?.show({ 
                    severity: 'success', 
                    summary: 'Success', 
                    detail: 'Employee created and resume uploaded and linked successfully!' 
                  });
                } catch (updateError) {
                  console.error('Fallback resume linking failed:', updateError);
                  toast.current?.show({ 
                    severity: 'warn', 
                    summary: 'Partial Success', 
                    detail: 'Employee created and resume uploaded, but failed to link them.' 
                  });
                }
              }
            } catch (fallbackError) {
              console.error('Fallback resume upload failed:', fallbackError);
              toast.current?.show({ 
                severity: 'warn', 
                summary: 'Partial Success', 
                detail: 'Employee created successfully, but resume upload failed. You can upload it later.' 
              });
            }
          }
        } else {
          toast.current?.show({ 
            severity: 'success', 
            summary: 'Success', 
            detail: 'Employee created successfully' 
          });
        }
      }

      console.log("API Response:", response);
      
      // Navigate back to employees list
      setTimeout(() => {
        navigate('/allactive-employees');
      }, 1000);

    } catch (error) {
      console.error("Error saving employee:", error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to save employee';
      toast.current?.show({ 
        severity: 'error', 
        summary: 'Error', 
        detail: errorMessage 
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (pathSegment) {
      getcategoriesitem(); // Call the function once the pathSegment is set
    }
  }, [pathSegment]);
  // Remove duplicate toast declaration
  // const toast = useRef(null);

  const showMessage = () => {
    toast.current.show({ severity: 'info', summary: 'Info', detail: 'Saved' });
  };



  const showCancel = () => {
    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Canceled', life: 3000 });
  }


  const [createdBy, setcreatedBy] = useState("")
  const [editedBy, seteditedBy] = useState("")

  // Open Full Name dialog and prefill values
  const openFullNameDialog = () => {
    // try to prefill from current fullname or form values
    const currentFull = fullname || `${formData.first_name || ''} ${formData.last_name || ''}`.trim();
    // split into parts conservatively
    const parts = currentFull.split(' ').filter(Boolean);
    const first = parts[0] || '';
    const last = parts.length > 1 ? parts.slice(1).join(' ') : '';

    setNameTitle('');
    setDialogFirstName(formData.first_name || first || '');
    setDialogMiddleName('');
    setDialogLastName(formData.last_name || last || '');
    setFullNameDialogVisible(true);
  }

  const handleFullNameSave = () => {
    const combined = [nameTitle, dialogFirstName, dialogMiddleName, dialogLastName].filter(Boolean).join(' ').trim();
    setFullname(combined);

    // Update form values for firstname and lastname as well
    setValue('firstname', dialogFirstName || '');
    setValue('lastname', dialogLastName || '');

    // Also keep internal formData in sync
    setFormData(prev => ({ ...prev, first_name: dialogFirstName || prev.first_name, last_name: dialogLastName || prev.last_name }));

    setFullNameDialogVisible(false);
    toast.current?.show({ severity: 'success', summary: 'Saved', detail: 'Name updated' });
  }

  const handleSavenavi = () => {
    // Trigger form submission by calling handleSubmit programmatically
    handleSubmit(onSubmit)();
  }
const [documentTypes, setdocumentTypes] = useState([]);
    const getDoctType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=contact_document_type`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status===200) {
                    const options = response.data.results.results.map((category) => ({
            name: category.value
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (char) => char.toUpperCase()),
            code: category.id,
            }));
            setdocumentTypes(options);
            }
        } catch (err) {
            console.log(err);

        }
    }
    useEffect(() => {
        getDoctType();
    }, []);
     useEffect(() => {
    if (visible) {
      const input = document.getElementById("autocomplete");

      if (input && window.google) {
        const autocomplete = new window.google.maps.places.Autocomplete(input, {
          types: ["geocode"], // restrict to addresses
          componentRestrictions: { country: "in" }, // restrict to India (optional)
        });

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();

          if (!place.address_components) return;

          let street1 = "";
          let street2 = "";
          let city = "";
          let state = "";
          let country = "";
          let postalCode = "";

          place.address_components.forEach((comp) => {
            if (comp.types.includes("street_number")) {
              street1 = comp.long_name + " " + street1;
            }
            if (comp.types.includes("route")) {
              street1 += comp.long_name;
            }
            if (comp.types.includes("sublocality_level_1")) {
              street2 = comp.long_name;
            }
            if (comp.types.includes("locality")) {
              city = comp.long_name;
            }
            if (comp.types.includes("administrative_area_level_1")) {
              state = comp.long_name;
            }
            if (comp.types.includes("country")) {
              country = comp.long_name;
            }
            if (comp.types.includes("postal_code")) {
              postalCode = comp.long_name;
            }
          });

          // Update your state
          setStreet1(street1);
          setStreet2(street2);
          setSelectedCity(city);
          setSelectedState(state);
          setSelectedCountry(country);
          setPostalCode(postalCode);
        });
      }
    }
  }, [visible]);
  const [FileNames, setFileNames] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedDocId, setSelectedDocId] = useState(null);
  const handleEdit = (doc) => {
    console.log('Editing document:', doc);
    setDisplayDialog(true);
    setSelectedDocId(doc.id);
    setIsEdit(true);
    setSubject(doc.description);
    setSelectedDocument(doc.type || null);
    const LastFiles = Array.isArray(doc.files)
      ? doc.files.map((fileItem, index) => ({
        id: `${doc.id}-${index}`,
        selectedId: fileItem.id,
        name: fileItem.original_filename,
        url: fileItem.file,
      }))
      : doc.files
        ? [{ id: doc.id, name: doc.files.original_filename, url: doc.files.file }]
        : [];

    setFileNames(LastFiles);
  };

          const handleDelete = async (rowKey) => {
              console.log('Deleting document with key:', rowKey);
              
              try {
                  const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/employees/${employeeId}/documents/${rowKey}/`, {
                      headers: {
                          Authorization: `Bearer ${token}`,
                      },
                  });
                  if (response.status === 200) {
                      getDocuments()
                      toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document deleted successfully', life: 3000 });
                  }
              } catch (err) {
                  console.log(err);
      
              }
          }
          const handleUpdateDocument = async () => {
          if (!selectedDocument || !subject) {
              alert('Please fill all the fields.');
              return;
          }
      
          try {
              const formData = new FormData();
      
              // Document type
              const docTypeObj = documentTypes.find(dt => dt.id === selectedDocument);
              const docTypeName = docTypeObj ? docTypeObj.name : selectedDocument;
              formData.append('type', selectedDocument);
              formData.append('description', subject);
      
              // Append newly uploaded files
              if (uploadedFiles && uploadedFiles.length > 0) {
                  uploadedFiles.forEach((file) => {
                      formData.append('uploaded_files', file);
                  });
              }
              if (FileNames && FileNames.length > 0) {
                  FileNames.forEach((file) => {
                      formData.append('files_to_keep', file.selectedId);
                  });
              }
      
              const response = await axios.patch(
                  `${process.env.REACT_APP_Company_Contact}/company/employees/${employeeId}/documents/${selectedDocId}/`,
                  formData,
                  {
                      headers: {
                          Authorization: `Bearer ${token}`,
                          'Content-Type': 'multipart/form-data'
                      }
                  }
              );
              if (response.status == 200 || response.status == 201) {
              getDocuments();
              setDisplayDialog(false);
              setSelectedDocument(null);
              setSubject('');
              setFileNames([]);
              setUploadedFiles([]);
              setIsEdit(false);
              }
      
              toast.current?.show({ severity: 'success', summary: 'Updated', detail: 'Document updated' });
      
          } catch (err) {
              console.error('Failed to update document', err);
              alert('Failed to update document');
          }
      };
  return (
    <React.Fragment>
      <div className="page-content can-editform">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={6}>
                <h1 className="page-title">{isEditMode ? 'Edit Employee' : 'Create a Employee'}</h1>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    {isEditMode 
                      ? 'Update employee details, skills, and contact information.' 
                      : 'Add a new employee by entering their details, skills, and contact information to streamline recruitment.'}
                  </li>
                </ol>
              </Col>
              <Col md={6}>
                <div className="d-flex justify-content-end">
                  <Toast ref={toast} />
                  <button 
                    type="button" 
                    onClick={handleSavenavi} 
                    className="btn btn-success me-2" 
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <i className="pi pi-spin pi-spinner me-1"></i> 
                        {isEditMode ? 'Updating...' : 'Saving...'}
                      </>
                    ) : (
                      <>
                        <i className="pi pi-save me-1"></i> 
                        {isEditMode ? 'Update' : 'Save'}
                      </>
                    )}
                  </button>

                  <Button
                    color="primary"
                    className="btn btn-primary me-2 cancel-outlinebtn"
                    onClick={() => navigate('/allactive-employees')}
                    disabled={isLoading}
                  >
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </Button>
                </div>

              </Col>
            </Row>
          </div>

          {/* Loading State */}
          {isLoading && isEditMode && !employeeData && (
            <div className="text-center p-5">
              <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
              <p className="mt-2">Loading employee data...</p>
            </div>
          )}

          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              {/* 1st Row */}
              <Col xl={4}>
                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">Basic Information</h4>
                    <Row>
                      <Col xl={12}>
                        <div className="">
                          <Row>
                            <Col xl={12}>
                              <Row className="mt-2 align-items-center"   >
                                <Col xl={3}>
                                  <label className=" block mb-2">
                                    Full name
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <InputText

                                    className="w-full"
                                    placeholder=""
                                    value={fullname}
                                    style={{ position: "relative" }}
                                    {...register("firstname", {
                                      required: "First name is required",
                                      pattern: {
                                        value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                        message:
                                          "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                      },
                                    })}
                                    onKeyUp={() => { trigger("firstname") }}
                                    onChange={(e) => {setFullname(e.target.value)}}
                                  />
                                  {errors.firstname && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.firstname.message}</small>)}
                                  {/* <i className="pi pi-pencil" style={{ position: "absolute", right: "26px", top: "28%", transform: "translateY(-50%)", color: "#6c757d", cursor: "pointer" }}
                                    onClick={() => openFullNameDialog()}
                                  ></i> */}

                                  <Dialog
                                    header="Edit Full Name"
                                    visible={fullNameDialogVisible}
                                    onHide={() => setFullNameDialogVisible(false)}
                                    style={{ width: '30vw' }}
                                    breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                  >

                                    <Row className="mb-2">
                                      <Col xl={12}>
                                        <label htmlFor="title" className="block">
                                          Title
                                        </label>
                                        <InputText
                                          id="title"
                                          className="w-full"
                                          value={nameTitle}
                                          onChange={(e) => setNameTitle(e.target.value)}
                                          placeholder="Mr"
                                        />
                                      </Col>
                                    </Row>

                                    <Row className="mb-2">
                                      <Col xl={12}>
                                        <label htmlFor="title" className="block">
                                          First Name
                                        </label>
                                        <InputText
                                          id="firstName"
                                          className="w-full"
                                          value={dialogFirstName}
                                          onChange={(e) => setDialogFirstName(e.target.value)}
                                          placeholder="Lavankumar"
                                        />
                                      </Col>
                                    </Row>

                                    <Row className="mb-2">
                                      <Col xl={12}>
                                        <label htmlFor="title" className="block">
                                          Middle Name
                                        </label>
                                        <InputText
                                          id="middleName"
                                          className="w-full"
                                          value={dialogMiddleName}
                                          onChange={(e) => setDialogMiddleName(e.target.value)}
                                          placeholder=""
                                        />
                                      </Col>
                                    </Row>

                                    <Row className="mb-2">
                                      <Col xl={12}>
                                        <label htmlFor="title" className="block">
                                          Last Name
                                        </label>
                                        <InputText
                                          id="lastName"
                                          className="w-full"
                                          value={dialogLastName}
                                          onChange={(e) => setDialogLastName(e.target.value)}
                                          placeholder="Kalvala"
                                        />
                                      </Col>
                                    </Row>

                                    <Row>
                                      <Col xl={12}>
                                        <div className="d-flex justify-content-end mt-2">
                                          <Button color="primary btn-main mr-2" onClick={handleFullNameSave}>
                                            Ok
                                          </Button>
                                          {/* <Button color="btn btn-primary cancel-outlinebtn" onClick={() => setShowDialog(false)}>
                                            <i className="pi pi-times me-1"></i>
                                            Cancel
                                          </Button> */}
                                        </div>
                                      </Col>
                                    </Row>
                                  </Dialog>
                                </Col>
                              </Row>


                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className=" block mb-2">
                                    Company
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <WorkType1
                                    initialWorkTypes={moduleWorkTypes}
                                    dropdownWorkTypes={moduleDropdownWorkTypes}
                                    onWorkTypesChange={handleModuleWorkTypesChange}
                                    onSelectionChange={handleModuleSelectionChange}
                                    selectedWorkType={selectedModule}
                                    lookupField={'company'}
                                    onSentinelSelect={handleSentinelSelect}
                                    useExternalModal={true}
                                    // itemTemplate={dropdownItemTemplate}
                                  />
                                  {errors.Company && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.Company.message}</small>)}

                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className=" block mb-2">
                                    Designation
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <WorkType1
                                    initialWorkTypes={designationWorkTypes}
                                    dropdownWorkTypes={designationDropdownWorkTypes}
                                    onWorkTypesChange={handleDesignationWorkTypesChange}
                                    onSelectionChange={handleDesignationSelectionChange}
                                    selectedWorkType={selectedDesignation}
                                    lookupField={'employee_designation'}
                                    onSentinelSelect={handleSentinelSelect}
                                    useExternalModal={true}
                                  />
                                  {errors.Designation && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.Designation.message}</small>)}

                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className="block mb-2">
                                    Status
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <WorkType1
                                    initialWorkTypes={basicStatusWorkTypes}
                                    dropdownWorkTypes={basicStatusDropdownWorkTypes}
                                    onWorkTypesChange={handleBasicStatusWorkTypesChange}
                                    onSelectionChange={handleBasicStatusSelectionChange}
                                    selectedWorkType={selectedBasicStatus}
                                    lookupField={'employee_status'}
                                    onSentinelSelect={handleSentinelSelect}
                                    useExternalModal={true}
                                  />
                                  {errors.Status && (<small id='statusHelp' className='form-text text-danger'>{errors.Status.message}</small>)}
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label htmlFor="totalExperience" className="block mb-2">
                                    Total Experience
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <InputNumber
                                    inputId="totalExperience"
                                    value={totalExperience}
                                    onValueChange={(e) => setTotalExperience(e.value)}
                                    minFractionDigits={1}
                                    maxFractionDigits={1}
                                    mode="decimal"
                                    placeholder=""
                                    className="w-full drop-clr"
                                  />
                                </Col>
                              </Row>

                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">Contact Information</h4>
                    <Row>
                      <Col xl={12}>
                        <div className="">
                          <Row>
                            <Col xl={12}>
                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label

                                    className=" block mb-2"
                                  >
                                    Email 1
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <InputText
                                    id="email"
                                    name="email"
                                    className="w-full"
                                    {...register("personal_email", {
                                      // required: "Please enter  Email",
                                      // pattern: {
                                      //   value:
                                      //     /^[A-Z0-9._%+-]+@[A-Z.-]{2,}\.+[A-Z]{2,}$/i,
                                      //   message:
                                      //     "Please enter valid Email", // JS only: <p>error message</p> TS only support string
                                      // },
                                      // onChange: (event) => event.target.value = event.target.value.toLowerCase()
                                    })}
                                    placeholder="lavan@varundigitalmedia.com"
                                  />

                                  {/* {errors.personal_email && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.personal_email.message}</small>)} */}
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className=" block mb-2">
                                    Email 2
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <InputText
                                    className="w-full"
                                    {...register("Email2", {})}
                                    placeholder="Email 2"
                                  />

                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label

                                    className=" block mb-2"
                                  >
                                    Work Phone
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <InputText
                                    id="office_phone"
                                    keyfilter="int"
                                    className="w-full"
                                    placeholder="9876543211"
                                    {...register("office_phone")}
                                  />
                                  {errors.office_phone && (<small className='form-text text-danger'>{errors.office_phone.message}</small>)}
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className=" block mb-2"                                  >
                                    Mobile Phone
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <InputText
                                    className="w-full"
                                    placeholder="9876543200"
                                    {...register("phone", {
                                      // required: "This field is required",
                                      // pattern: {
                                      //   value:
                                      //     /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/,
                                      //   message: "Please enter a valid mobile number.",
                                      // },
                                      // minLength: {
                                      //   value: 10,
                                      //   message: "Please enter Min and Max 10 digits ",
                                      // },
                                      // maxLength: {
                                      //   value: 10,
                                      //   message: "Please enter Min and Max 10 digits ",
                                      // },

                                    })}

                                  // onKeyUp={(e) => {
                                  //   trigger("phone");

                                  // }}
                                  />
                                  {/* {errors.phone && (<small id='phoneNoHelp' className='form-text text-danger'>{errors.phone.message}</small>)} */}
                                </Col>
                              </Row>

                              {/* <Row className="mt-2 align-items-center">
                              <Col xl={4}>
                                <label
                                 
                                  className=" block mb-2"
                                >
                                  Address
                                </label>
                              </Col>
                              <Col xl={8}>
                                <InputText
                                  id="integer"
                                  keyfilter="int"
                                  className="w-full"
                                  placeholder="Country, Street address, Street address line 2, City*,Pincode,State, Label(work/home/other)"
                                />
                              </Col>
                            </Row> */}

                              <Row className="mt-2 align-items-center">
                                
                                <Col xl={3}>
                                  <label htmlFor="address">Address</label>
                                </Col>
                                <Col xl={9}>

                                  <div className="companie-add" style={{ position: "relative" }}>
                                    <InputTextarea
                                      id="address"
                                      value={address}
                                      // onChange={(e) => setAddress(e.target.value)}
                                      readOnly
                                      placeholder=""
                                      rows={3}
                                      cols={20}
                                      className="w-full"
                                    />

                                    {/* Edit Icon */}
                                    <i
                                      className="pi pi-pencil"
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "70%",
                                        transform: "translateY(-50%)",
                                        color: "#6c757d",
                                        cursor: "pointer"
                                      }}
                                      onClick={() => setVisible(true)}
                                    ></i>
                                     <Dialog header="Edit Address" className="address-popup" visible={visible} onHide={() => {
                                                                setVisible(false);
                                                                setStreet1('');
                                                                setStreet2('');
                                                                setSelectedCity(null);
                                                                setSelectedState(null);
                                                                setSelectedCountry(null);
                                                                setPostalCode('');
                                                                setSelectedLabel(null);
                                                                setAddress('');
                                                              }}
                                                                style={{ width: '30vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                                                                <div className="card sidebardetails">
                                                                  <form>
                                    
                                                                    <Row className="mb-3">
                                                                      <Col lg={6}>
                                                                        <div className="p-field">
                                                                          <label htmlFor="street1">Street 1</label>
                                                                          <InputText
                                                                            id="street1"
                                                                            value={street1}
                                                                            onChange={(e) => { setStreet1(e.target.value); updateAddress(); }}
                                                                            placeholder="Enter Street 1"
                                                                            className="w-full activejobdrop"
                                                                          />
                                                                        </div>
                                                                      </Col>
                                                                      <Col lg={6}>
                                                                        <label htmlFor="street2">Street 2</label>
                                                                        <InputText
                                                                          id="street2"
                                                                          value={street2}
                                                                          onChange={(e) => { setStreet2(e.target.value); updateAddress(); }}
                                                                          placeholder="Enter Street 2 (Optional)"
                                                                          className="w-full activejobdrop"
                                                                        />
                                                                      </Col>
                                                                    </Row>
                                    
                                    
                                    
                                                                    <Row className="mb-3">
                                    
                                    
                                                                      <Col lg={6}>
                                                                        <label htmlFor="city">Citysa</label>
                                                                        <Dropdown
                                                                          id="city"
                                                                          value={selectedCity}
                                                                          onChange={(e) => { updateAddress(); setSelectedCity(e.value) }}
                                                                          options={addCities}
                                                                          optionLabel="name"
                                                                          filter
                                                                          filterPlaceholder="Search City"
                                                                          className="w-full activejobdrop"
                                                                          placeholder="Select City"
                                                                        />
                                                                      </Col>
                                                                      <Col lg={6}>
                                                                        <label htmlFor="state">State</label>
                                                                        <Dropdown
                                                                          id="state"
                                                                          value={selectedState}
                                                                          onChange={(e) => { updateAddress(); setSelectedState(e.value) }}
                                                                          options={addStates}
                                                                          optionLabel="name"
                                                                          filter
                                                                          filterPlaceholder="Search State"
                                                                          className="w-full activejobdrop"
                                                                          placeholder="Select State"
                                                                        />
                                                                      </Col>
                                                                    </Row>
                                    
                                                                    <Row className="mb-3">
                                                                      <Col lg={6}>
                                                                        <label htmlFor="country">Country</label>
                                                                        <Dropdown
                                                                          id="country"
                                                                          value={selectedCountry}
                                                                          onChange={(e) => { updateAddress(); setSelectedCountry(e.value) }}
                                                                          options={addCountries}
                                                                          optionLabel="name"
                                                                          filter
                                                                          filterPlaceholder="Search Country"
                                                                          className="w-full activejobdrop"
                                                                          placeholder="Select Country"
                                                                        />
                                                                      </Col>
                                                                      <Col lg={6}>
                                                                        <label htmlFor="postalCode">Postal Code</label>
                                                                        <InputText
                                                                          id="postalCode"
                                                                          value={postalCode}
                                                                          onChange={(e) => { updateAddress(); setPostalCode(e.target.value) }}
                                                                          placeholder=""
                                                                          className="w-full activejobdrop"
                                                                        />
                                                                      </Col>
                                                                    </Row>
                                    
                                                                    <Row className="mb-3">
                                                                      <Col lg={12}>
                                                                        <label htmlFor="postalCode">Label</label>
                                                                        <Dropdown
                                                                          value={selectedLabel}
                                                                          onChange={(e) => { updateAddress(); setSelectedLabel(e.value) }}
                                                                          options={labels}
                                                                          optionLabel="name"
                                                                          placeholder="Work From Office"
                                                                          className="w-full activejobdrop"
                                                                        />
                                                                      </Col>
                                                                    </Row>
                                                                    <Row>
                                                                      <Col>
                                                                        <Button
                                                                          type="button"
                                                                          color="primary"
                                                                          className="btn btn-primary waves-effect waves-light me-2 sidebarbtn"
                                                                          onClick={() => { setVisible(false); }}
                                                                        >
                                                                          <i className="pi pi-check me-1"></i> Save
                                                                        </Button>
                                    
                                                                        <Button
                                                                          type="button"
                                                                          color="primary"
                                                                          className="btn btn-primary waves-effect waves-light cancelbtn me-2"
                                                                          onClick={() => {
                                                                            setVisible(false);
                                                                            setStreet1('');
                                                                            setStreet2('');
                                                                            setSelectedCity(null);
                                                                            setSelectedState(null);
                                                                            setSelectedCountry(null);
                                                                            setPostalCode('');
                                                                            setSelectedLabel(null);
                                                                            setAddress('');
                                                                          }}
                                                                        >
                                                                          <i className="pi pi-times me-1"></i>
                                                                          Cancel
                                                                        </Button>
                                                                      </Col>
                                                                    </Row>
                                                                  </form>
                                                                </div>
                                                              </Dialog>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

             


              </Col>
              {/* 1st Row */}

              {/* 2nd Row */}

              <Col xl={4}>
                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">General Information</h4>
                    <Row>
                      <Col xl={12}>
                        <div className="">
                          <Row>
                            <Col xl={12} >

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                 
                                </Col>
                                <Col xl={9}>
                                 
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className="block mb-2">
                                    Department
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <WorkType1
                                    initialWorkTypes={departmentWorkTypes}
                                    dropdownWorkTypes={departmentDropdownWorkTypes}
                                    onWorkTypesChange={handleDepartmentWorkTypesChange}
                                    onSelectionChange={handleDepartmentSelectionChange}
                                    selectedWorkType={selectedDepartment}
                                    lookupField={'employee_department'}
                                    onSentinelSelect={handleSentinelSelect}
                                    useExternalModal={true}
                                  />
                                  {errors.Department && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.Department.message}</small>)}
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className="block mb-2">
                                    Sub Department
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <WorkType1
                                    initialWorkTypes={subDepartmentWorkTypes}
                                    dropdownWorkTypes={subDepartmentDropdownWorkTypes}
                                    onWorkTypesChange={handleSubDepartmentWorkTypesChange}
                                    onSelectionChange={handleSubDepartmentSelectionChange}
                                    selectedWorkType={selectedSubDepartment}
                                    lookupField={'employee_subDepartment'}
                                    onSentinelSelect={handleSentinelSelect}
                                    useExternalModal={true}
                                  />
                                  {errors.SubDepartment && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.SubDepartment.message}</small>)}
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className="block mb-2">
                                    Work Location
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <WorkType1
                                    initialWorkTypes={workLocationWorkTypes}
                                    dropdownWorkTypes={workLocationDropdownWorkTypes}
                                    onWorkTypesChange={handleWorkLocationWorkTypesChange}
                                    onSelectionChange={handleWorkLocationSelectionChange}
                                    selectedWorkType={selectedWorkLocation}
                                    lookupField={'employee_workLocation'}
                                    onSentinelSelect={handleSentinelSelect}
                                    useExternalModal={true}
                                  />
                                  {errors.WorkLocation && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.WorkLocation.message}</small>)}
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className="block mb-2">
                                    Shift Timings
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <WorkType1
                                    initialWorkTypes={shiftTimingsWorkTypes}
                                    dropdownWorkTypes={shiftTimingsDropdownWorkTypes}
                                    onWorkTypesChange={handleShiftTimingsWorkTypesChange}
                                    onSelectionChange={handleShiftTimingsSelectionChange}
                                    selectedWorkType={selectedShiftTimings}
                                    lookupField={'employee_shiftTimings'}
                                    onSentinelSelect={handleSentinelSelect}
                                    useExternalModal={true}
                                  />
                                  {errors.ShiftTimings && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.ShiftTimings.message}</small>)}
                                </Col>
                              </Row>

                              {/* <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className="block mb-2">
                                    Employee Status
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <WorkType1
                                    initialWorkTypes={empStatusWorkTypes}
                                    dropdownWorkTypes={empStatusDropdownWorkTypes}
                                    onWorkTypesChange={handleEmpStatusWorkTypesChange}
                                    onSelectionChange={handleEmpStatusSelectionChange}
                                    selectedWorkType={selectedEmpStatus}
                                    lookupField={'employee_employeeStatus'}
                                    onSentinelSelect={handleSentinelSelect}
                                    useExternalModal={true}
                                  />
                                  {errors.EmployeeStatus && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.EmployeeStatus.message}</small>)}
                                </Col>
                              </Row> */}

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className="block mb-2">
                                    Employee Type
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <WorkType1
                                    initialWorkTypes={employeeTypeWorkTypes}
                                    dropdownWorkTypes={employeeTypeDropdownWorkTypes}
                                    onWorkTypesChange={handleEmployeeTypeWorkTypesChange}
                                    onSelectionChange={handleEmployeeTypeSelectionChange}
                                    selectedWorkType={selectedEmployeeType}
                                    lookupField={'employee_employeeType'}
                                    onSentinelSelect={handleSentinelSelect}
                                    useExternalModal={true}
                                  />
                                  {errors.EmployeeType && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.EmployeeType.message}</small>)}
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className="block mb-2">
                                    Reporting Manager
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <WorkType1
                                    initialWorkTypes={reportingManagerWorkTypes}
                                    dropdownWorkTypes={reportingManagerDropdownWorkTypes}
                                    onWorkTypesChange={handleReportingManagerWorkTypesChange}
                                    onSelectionChange={handleReportingManagerSelectionChange}
                                    selectedWorkType={selectedReportingManager}
                                    lookupField={'reporting_manager'}
                                    onSentinelSelect={handleSentinelSelect}
                                    useExternalModal={true}
                                  />
                                  {errors.ReportingManager && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.ReportingManager.message}</small>)}
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className="block mb-2">
                                    Date of Joining
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <Calendar className="w-100"
                                    id="dateOfJoining"
                                    value={dateOfJoining}
                                    onChange={(e) => setDateOfJoining(e.value)}
                                    placeholder="01/01/2025"
                                    showIcon
                                  />
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label

                                    className=" block mb-2"
                                  >
                                    DoB
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <Calendar className="w-100"
                                    id="buttondisplay"
                                    value={dob}
                                    onChange={(e) => setDob(e.value)}
                                    placeholder="20/02/2025"
                                    showIcon
                                  />
                                </Col>
                              </Row>



                              {/* <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className=" block mb-2">
                                    Availability Date
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <Calendar className="w-100"
                                    id="buttondisplay"
                                    value={dateAvalibility}
                                    onChange={(e) => setDateAvalibility(e.value)}
                                    placeholder="28/02/2025"
                                    showIcon
                                  />
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label className=" block mb-2">
                                    Source
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <InputText
                                    id="integer"
                                    keyfilter="int"
                                    className="w-full"
                                    placeholder="LinkedIn"
                                  />
                                </Col>
                              </Row>



                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label

                                    className=" block mb-2"
                                  >
                                    Referred By
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <InputText
                                    id="integer"
                                    keyfilter="int"
                                    className="w-full"
                                    placeholder="Salmanuddin Syed"
                                  />
                                </Col>
                              </Row> */}

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label

                                    className=" block mb-2"
                                  >
                                    Categories
                                  </label>
                                </Col>
                                <Col xl={9}>

                                  <TreeSelect
                                    value={selectedCategoryKey}
                                    onChange={(e) => setSelectedCategoryKey(e.value)}
                                    options={categoriesAPIData}
                                    filter
                                    className="w-full"
                                    placeholder="Frontend"
                                  ></TreeSelect>
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label

                                    className=" block mb-2"
                                  >
                                    Groups
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <TreeSelect
                                    value={selectedGroupKey}
                                    onChange={(e) => setSelectedGroupKey(e.value)}
                                    options={groupsAPIData}
                                    filter
                                    className="w-full"
                                    placeholder="React"
                                  ></TreeSelect>
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center justify-content-end">
                                {/* <Col lg={12}>
                                  <Row>
                                    <Col xl={6}>
                                      <label

                                        className=" block mb-2"
                                      >
                                        Relocation
                                      </label>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="relocation">
                                        <input
                                          type='checkbox'
                                          className="me-2"
                                          checked
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </Col> */}
                                <Col lg={12}>
                                  <Row className="align-items-center">
                                    <Col xl={3}>
                                      <label className="block mb-2">
                                        Private
                                      </label>
                                    </Col>
                                    <Col xl={1}>
                                      <div className="d-flex align-items-center">
                                        <Checkbox
                                          inputId="privateCheckbox"
                                          checked={privateDrop}
                                          onChange={(e) => setPrivateDrop(e.checked)}
                                        />
                                      </div>
                                         </Col>
                                         <Col xl={8}>
                                      {privateDrop && (
                                        <div className="p-field">
                                          {/* <label htmlFor="userIds">User Id's</label> */}
                                          <MultiSelect
                                            value={PrivetDropdown}
                                            onChange={(e) => setPrivetDropdown(e.value)}
                                            options={PrivetDropdownValues}
                                            optionLabel={(option) => `${option.name}, ${option.email}`}
                                            display="comma"
                                            placeholder="Select User Id's"
                                            maxSelectedLabels={10}
                                            className="w-full"
                                            optionValue="code"
                                          />
                                        </div>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">Resume </h4>
                    <Row>
                      <Col xl={12}>
                        <div className="">
                          <Row>
                            <Col xl={12}>
                              {/* <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label
                                 
                                  className=" block mb-2"
                                >
                                  Resume
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
                                  id="integer"
                                  keyfilter="int"
                                  className="w-full"
                                />

                              </Col>
                            </Row> */}

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label

                                    className=" block mb-2"
                                  >
                                    Resume Attachment
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  {/* <FileUpload
                                    ref={fileUploadRef}
                                    name="files[]"
                                    accept="image/jpg,image/jpeg,image/png,application/pdf"
                                    maxFileSize={1000000}
                                    multiple
                                    customUpload
                                    auto
                                    uploadHandler={(e) => {
                                      setUploadedFiles(e.files)
                                    }}
                                    onClear={() => {
                                      console.log("Files cleared")
                                      setUploadedFiles([])
                                    }}
                                  /> */}
                                  <div className="block d-flex justify-content-end align-items-center">
                                    <a color="primary" className="anchr-title mt-3" onClick={openAddDocumentDialog}>
                                      <i className="pi pi-plus me-1"></i> Add More
                                    </a>
                                  </div>
                                  {/* <FileUpload
                                    mode="basic"
                                    name="resume[]"
                                    url="/api/upload"
                                    accept=".pdf,.doc,.docx,.txt"
                                    maxFileSize={5000000}
                                    chooseLabel={isUploadingResume ? "Uploading..." : "Choose Resume"}
                                    customUpload
                                    uploadHandler={handleResumeUpload}
                                    disabled={isUploadingResume}
                                    className="custom-fileupload"
                                  /> */}
                                  {/* {resumeFile && (
                                    <small className="text-info d-block mt-1">
                                      Selected: {resumeFile.name} ({(resumeFile.size / 1024 / 1024).toFixed(2)} MB)
                                    </small>
                                  )}
                                  {resumeDocumentId && (
                                    <small className="text-success d-block mt-1">
                                      ✓ Resume document uploaded successfully
                                    </small>
                                  )} */}
                                </Col>
                              </Row>

                              {/* Display current employee documents */}
                              {isEditMode && (
                                <Row className="mt-3">
                                  <Col xl={12}>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <strong>Employee Documents:</strong>
                                      <Button 
                                        size="small" 
                                        icon="pi pi-refresh" 
                                        className="p-button-text" 
                                        onClick={refreshEmployeeDocuments}
                                        tooltip="Refresh documents"
                                      />
                                    </div>
                                    {employeeDocuments.length > 0 ? (
                                      <div className="documents-list">
                                        {employeeDocuments.map((doc, index) => (
                                          <div key={index} className="document-item mb-2 p-2 border rounded bg-light">
                                            <div className="d-flex justify-content-between align-items-center">
                                              <div>
                                                <span className="fw-bold text-primary">{doc.type}</span>
                                                {doc.description && <div className="text-muted small">{doc.description}</div>}
                                              </div>
                                              <small className="text-muted">
                                                {new Date(doc.created_at).toLocaleDateString()}
                                              </small>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div className="text-muted">No documents uploaded yet.</div>
                                    )}
                                  </Col>
                                </Row>
                              )}


                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                
              </Col>

              {/* 2nd Row */}

              {/* 3rd Row */}

              <Col xl={4}>

                 <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">Skills</h4>
                    <Row>
                      <Col xl={12}>
                        <div className="">
                          <Row>
                            <Col xl={12}>
                              {/* Primary Skills Dropdown */}
                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label htmlFor="primary" className="block mb-2">Primary Skills</label>
                                </Col>
                                <Col xl={9}>
                                  <div className="flex justify-content-center mb-0">
                                    {/* <Select
                                      id="primarySkills"
                                      name="primarySkills"
                                      isMulti
                                      options={primarySkillsAPIData}
                                      value={primarySkillsAPIData.filter(option => selectedPrimarySkills.includes(option.value))}
                                      onChange={handlePrimarySkillsChange}
                                      placeholder="Javascript, React"
                                      className="w-full"
                                      getOptionLabel={(option) => option.label || option.name}
                                      getOptionValue={(option) => option.value}
                                    /> */}
                                    <Chips
                                      id="primarySkills"
                                      value={selectedPrimarySkills || []}
                                      onChange={(e) => setSelectedPrimarySkills(e.value || [])}
                                      className="w-full"
                                      separator=","
                                      placeholder="Type a skill and press Enter"
                                      addOnBlur={true}
                                    />
                                  </div>
                                </Col>
                              </Row>

                              {/* Secondary Skills Dropdown */}
                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label htmlFor="secondary" className="block mb-2">Secondary Skills</label>
                                </Col>
                                <Col xl={9}>
                                  <Chips
                                    id="secondarySkills"
                                    value={secondarySkills || []}
                                    onChange={(e) => setSecondarySkills(e.value || [])}
                                    className="w-full"
                                    placeholder="Type a skill and press Enter"
                                    addOnBlur={true}
                                  />
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label htmlFor="other" className="block mb-2">Other Skills</label>
                                </Col>
                                <Col xl={9}>
                                  <Chips
                                    id="otherSkills"
                                    value={otherSkills || []}
                                    onChange={(e) => setOtherSkills(e.value || [])}
                                    className="w-full"
                                    placeholder="Type a skill and press Enter"
                                    addOnBlur={true}
                                  />
                                </Col>
                              </Row>

                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>


                
                                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">Documents</h4>
                    <Row>
                      <Col xl={12}>
                        <div>
                          {/* Button to trigger the modal */}
                          {/* <Button
                          label="Add Document"
                          icon="pi pi-plus"
                          className="p-button-success"
                          onClick={openAddDocumentDialog}
                        /> */}



                          {/* DataTable to display added documents */}
                          <Row className="mt-2">
                            <Col xl={12}>
                              {/* <h5>Added Documents:</h5> */}
                              <Row>
                                <Col xl={12}>
                                  <div>
                                    <DataTable
                                      value={documents}
                                      rows={5}
                                      className="p-datatable-gridlines"
                                      emptyMessage={<div className="empty-message-custom">No documents found.</div>}
                                    >
                                      <Column
                                        field="type_name"
                                        header="Document Type"
                                      />
                                      <Column
                                        field="description"
                                        header="Subject"
                                      />
                                      <Column
                                        field="created_at"
                                        header="Uploaded On"
                                        body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                      />
                                      <Column
                                        header="Attachments"
                                        body={(rowData) => rowData.files && rowData.files.length > 0 ? (
                                          <ul className="list-unstyled mb-0">
                                            {rowData.files.map((fileItem) => (
                                              <li key={fileItem.id}>
                                                <a href={fileItem.file} target="_blank" rel="noopener noreferrer">
                                                  {fileItem.original_filename} ({(fileItem.file_size / 1024).toFixed(2)} KB)
                                                </a>
                                              </li>
                                            ))}
                                          </ul>
                                        ) : 'No file'}
                                      />
                                      <Column
                                        header="Actions"
                                        body={(rowData) => (
                                          <div className="d-flex gap-2">
                                            <Button
                                              type="button"
                                              icon="pi pi-pencil"
                                              className="p-button-rounded p-button-text p-button-info"
                                              tooltip="Edit"
                                              onClick={() => handleEdit(rowData)}
                                            />
                                            <Button
                                              icon="pi pi-trash"
                                              className="p-button-rounded p-button-text p-button-danger"
                                              tooltip="Delete"
                                              type="button"
                                              onClick={() => handleDelete(rowData.id)}
                                            />
                                          </div>
                                        )}
                                      />
                                    </DataTable>
                                    <div className="block d-flex justify-content-end align-items-center">
                                      <a color="primary" className="anchr-title mt-3" onClick={openAddDocumentDialog}>
                                        <i className="pi pi-plus me-1"></i> Add More
                                      </a>
                                    </div>
                                  </div>
                                </Col>
                              </Row>

                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>

                  {/* Dialog for adding document */}
                  <Dialog
                    header="Add Document"
                    visible={displayDialog}
                    onHide={() => { { setDisplayDialog(false); setSelectedDocument(null); setSubject(''); setUploadedFiles([]); setIsEdit(false); setFileNames([]) } }}
                    style={{ width: "30vw" }}
                    footer={
                      <div className="d-flex justify-content-end gap-2">
                        {isEdit ? <Button color="primary btn-main mr-2" onClick={handleUpdateDocument}>
                          <i className="pi pi-pencil me-1"></i>
                          Update
                        </Button> :
                          <Button color="primary btn-main mr-2" onClick={handleAddDocument}>
                            <i className="pi pi-plus me-1"></i>
                            Add Document
                          </Button>}
                        <Button color="btn btn-primary cancel-outlinebtn" onClick={() => { { setDisplayDialog(false); setSelectedDocument(null); setSubject(''); setUploadedFiles([]) } }}>
                          <i className="pi pi-times me-1"></i>
                          Cancel
                        </Button>
                      </div>
                    }
                  >
                    <Row className="mt-2 align-items-center">
                      <Col xl={3}>
                        <label htmlFor="type" className="block mb-2">
                          Type
                        </label>
                      </Col>
                      <Col xl={9}>
                        <Dropdown
                          id="project"
                          value={selectedDocument}
                          onChange={(e) => setSelectedDocument(e.value)}
                          options={[
                            ...documentTypes,
                            { code: 'add', name: 'Add New', icon: 'pi pi-plus' },
                            ...(selectedDocument ? [{ code: 'edit', name: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                          ]}
                          placeholder="Select Document Type"
                          className="w-full bgclr"
                          optionLabel="name"
                          optionValue="code"
                          filter
                          itemTemplate={(option) => (
                            <div className="flex align-items-center gap-2">
                              {option?.icon && <i className={option.icon}></i>}
                              <span>{option.name}</span>
                            </div>
                          )}
                        />
                      </Col>
                    </Row>

                    <Row className="mt-2 align-items-center">
                      <Col xl={3}>
                        <label htmlFor="subject" className="block mb-2">
                          Description
                        </label>
                      </Col>
                      <Col xl={9}>
                        <InputText
                          id="subject"
                          value={subject}
                          onChange={(e) => setSubject(e.target.value)}
                          className="w-full"
                          style={{ border: '1px solid #ced4da' }}
                        />
                      </Col>
                    </Row>

                    <Row className="mt-2 align-items-center">
                      <Col xl={3}>
                        <label htmlFor="attachment" className="block mb-2">
                          Attachment
                        </label>
                      </Col>
                      <Col xl={9}>
                        <FileUpload
                          ref={fileUploadRef}
                          name="files[]"
                          accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          maxFileSize={5242880}
                          multiple
                          customUpload
                          auto={false}
                          onSelect={(e) => {
                            // Get current files (previously uploaded ones)
                            const currentFiles = uploadedFiles || [];

                            // Validate individual file types first for new files
                            const allowedTypes = [
                              'image/jpg', 'image/jpeg', 'image/png',
                              'application/pdf',
                              'application/msword', // .doc
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                              'text/plain', // .txt
                              'application/vnd.ms-excel', // .xls
                              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
                            ];

                            const validNewFiles = e.files.filter(file => allowedTypes.includes(file.type));
                            const invalidFiles = e.files.filter(file => !allowedTypes.includes(file.type));

                            if (invalidFiles.length > 0) {
                              toast.current?.show({
                                severity: "error",
                                summary: "Invalid File Type",
                                detail: `File(s) rejected: ${invalidFiles.map(f => f.name).join(', ')}. Only Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX are allowed.`,
                                life: 5000
                              });

                              // If there are valid files, continue with them; otherwise clear and return
                              if (validNewFiles.length === 0) {
                                // Clear the component and restore previous files
                                setTimeout(() => {
                                  if (fileUploadRef.current) {
                                    fileUploadRef.current.clear();
                                    // Restore previous files to the component
                                    if (currentFiles.length > 0) {
                                      fileUploadRef.current.setFiles(currentFiles);
                                    }
                                  }
                                }, 0);
                                return;
                              }
                            }

                            // Combine current files with valid new files
                            const allFiles = [...currentFiles, ...validNewFiles];

                            // Calculate total size of all files (current + new valid files)
                            const totalSize = allFiles.reduce((sum, file) => sum + file.size, 0);
                            const maxTotalSize = 5242880; // 5MB total limit (5 * 1024 * 1024)
                            const totalSizeMB = totalSize / (1024 * 1024);

                            console.log(`File validation - Current files: ${currentFiles.length}, New files: ${validNewFiles.length}, Total files: ${allFiles.length}, Total size: ${totalSizeMB.toFixed(3)}MB, Limit: ${(maxTotalSize / (1024 * 1024)).toFixed(1)}MB`);

                            if (totalSize > maxTotalSize) {
                              const currentSizeMB = currentFiles.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);
                              const newSizeMB = validNewFiles.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);

                              toast.current?.show({
                                severity: "error",
                                summary: "File Size Error",
                                detail: `Cannot add ${validNewFiles.length} file(s) (${newSizeMB.toFixed(2)}MB). Current files: ${currentSizeMB.toFixed(2)}MB, Total would be: ${totalSizeMB.toFixed(2)}MB. Maximum allowed: 5MB.`,
                                life: 5000
                              });

                              // Clear the component and restore only previous files
                              setTimeout(() => {
                                if (fileUploadRef.current) {
                                  fileUploadRef.current.clear();
                                  // Restore only the previous files, not the new ones
                                  if (currentFiles.length > 0) {
                                    fileUploadRef.current.setFiles(currentFiles);
                                  }
                                }
                              }, 0);
                              return;
                            }

                            // Success - files are valid
                            toast.current?.show({
                              severity: "success",
                              summary: "Files Added",
                              detail: `${validNewFiles.length} file(s) added. Total: ${allFiles.length} files (${totalSizeMB.toFixed(2)}MB)`,
                              life: 3000
                            });

                            setUploadedFiles(allFiles);
                            console.log(`Upload ready - Total files: ${allFiles.length}, Total size: ${totalSizeMB.toFixed(3)}MB`);
                          }}
                          uploadHandler={(e) => {
                            // This will be called when files are manually uploaded
                            console.log('Upload handler called', e.files);
                          }}
                          onClear={() => {
                            console.log("Files cleared")
                            setUploadedFiles([])
                          }}
                        />
                        <small className="text-muted">
                          Maximum total file size: 5MB. Accepted formats: Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX
                        </small>
                      </Col>
                      {FileNames && FileNames.length > 0 && (
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">Previously Attached Files</label>
                          </Col>
                          <Col xl={9}>
                            {FileNames.map((file) => (
                              <div key={file.id} className="d-flex align-items-center mb-2">
                                <a
                                  href={file.url || file.name} // use URL if available
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="me-2"
                                >
                                  {file.name.split('/').pop()}
                                </a>
                                <i
                                  className="pi pi-times"
                                  style={{ cursor: "pointer", color: "red" }}
                                  onClick={() => {
                                    // Remove the clicked file from FileNames
                                    setFileNames(prev => prev.filter(f => f.id !== file.id));
                                  }}
                                ></i>
                              </div>
                            ))}
                          </Col>

                        </Row>
                      )}
                    </Row>
                  </Dialog>
                </Card>


                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">System Fields</h4>
                    <Row>
                      <Col xl={12}>
                        <div className="">
                          <Row>
                            <Col xl={12}>
                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label

                                    className=" block"
                                  >
                                    Create Date
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <Calendar
                                    id="createDate"
                                    placeholder="27/02/2025"
                                    className="w-full"
                                    disabled
                                  />
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label

                                    className=" block"
                                  >
                                    Edit Date
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <Calendar
                                    id="editDate"
                                    disabled
                                    className="w-full"
                                    placeholder="27/02/2025"
                                  />
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label

                                    className=" block"
                                  >
                                    Created By
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <InputText
                                    id="integer"
                                    className="w-full"
                                    disabled
                                    value={createdBy}
                                  />
                                </Col>
                              </Row>

                              <Row className="mt-2 align-items-center">
                                <Col xl={3}>
                                  <label

                                    className=" block"
                                  >
                                    Edited By
                                  </label>
                                </Col>
                                <Col xl={9}>
                                  <InputText
                                    id="integer"
                                    className="w-full"
                                    placeholder=""
                                    disabled
                                    value={editedBy}
                                  />
                                </Col>
                              </Row>

                            


                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              {/* 3rd Row */}
            </Row >

            <Row className="align-items-center mb-3">

              <Col md={12}>
                <div className="d-flex justify-content-end">
                  <button type="submit" class="btn btn-success me-2" onClick={handleSavenavi}> <i className="pi pi-save me-1"></i> Save</button>

                  <button type="button" class="btn btn-primary  me-2 cancel-outlinebtn" onClick={handleSavenavi}> <i className="pi pi-times me-1"></i> Cancel</button>


                </div>

              </Col>
            </Row>
          </form>

          {/* Lookup Modal Dialog */}
          <Dialog
            header={`${editingLookup ? 'Edit' : 'Add New'} ${lookupModalContext.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())}`}
            visible={lookupModalVisible}
            style={{ width: '50vw' }}
            onHide={() => setLookupModalVisible(false)}
          >
            <div className="p-fluid">
              {editingLookup && (
                <div className="field">
                  <label htmlFor="edit-select">Select to Edit</label>
                  <Dropdown
                    id="edit-select"
                    value={selecteddropoptions.find(opt => opt.id === lastSelectedLookupId)}
                    onChange={(e) => {
                      setLastSelectedLookupId(e.value?.id || e.value?.code || e.value?.value);
                      setLookupFormValue(e.value?.name || e.value?.label || e.value?.value || '');
                      setLookupDescription(e.value?.description || '');
                    }}
                    options={selecteddropoptions}
                    optionLabel={(option) => option?.name || option?.label || option?.value || ''}
                    placeholder="Select an option to edit"
                    className="w-full bgclr"
                  />
                </div>
              )}
              <div className="field">
                <label htmlFor="lookup-name">Name</label>
                <InputText
                  id="lookup-name"
                  value={lookupFormValue}
                  onChange={(e) => setLookupFormValue(e.target.value)}
                  placeholder="Enter name"
                />
              </div>
              <div className="field">
                <label htmlFor="lookup-description">Description</label>
                <InputTextarea
                  id="lookup-description"
                  value={lookupDescription}
                  onChange={(e) => setLookupDescription(e.target.value)}
                  placeholder="Enter description"
                  rows={3}
                />
              </div>
              <div className="d-flex justify-content-end gap-2">
                <Button
                  label={editingLookup ? 'Update' : 'Save'}
                  icon="pi pi-check"
                  onClick={handleLookupSave}
                  className="p-button-primary w-25"
                />
                <Button
                  label="Cancel"
                  icon="pi pi-times"
                  onClick={() => setLookupModalVisible(false)}
                  className="p-button-secondary w-25"
                />
              </div>
            </div>
          </Dialog>

          <Dialog
            header="Duplicate Resumes"
            visible={merge}
            style={{ width: '30vw' }}
            onHide={() => {
              if (!merge) return;
              setMerge(false);
            }}
            footer={footerContent}
          >
            <p className="m-0">
              <h4 className="popup-merge">The employees already exists. Do you want to merge?</h4>
            </p>
          </Dialog>
        </Container >
      </div >
    </React.Fragment >
  )
}

export default EmployeeEditForm;
